webpackJsonp([5],{

/***/ 3703:
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(3149),
	    arrayIncludes = __webpack_require__(3704),
	    arrayIncludesWith = __webpack_require__(3705),
	    arrayMap = __webpack_require__(1209),
	    baseUnary = __webpack_require__(1659),
	    cacheHas = __webpack_require__(3153);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },

/***/ 3704:
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(2330);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },

/***/ 3705:
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },

/***/ 3706:
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(1654),
	    isObjectLike = __webpack_require__(695);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },

/***/ 3884:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(3829);
	
	var _redux = __webpack_require__(684);
	
	var _PreviewBlueprints = __webpack_require__(3885);
	
	var _PreviewBlueprints2 = _interopRequireDefault(_PreviewBlueprints);
	
	var _constants = __webpack_require__(1662);
	
	var _actions = __webpack_require__(3883);
	
	var _selectors = __webpack_require__(3912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: state[_constants.STORE_NAMESPACE].blueprints.loading,
	    blueprints: state[_constants.STORE_NAMESPACE].blueprints.cards,
	    accounts: state[_constants.STORE_NAMESPACE].blueprints.accounts,
	    mediaFBActionUrl: (0, _selectors.buildMediaFBActionURL)(state),
	    WSSEToken: state.session.wsse,
	    uploadingMediaToFB: state[_constants.STORE_NAMESPACE].blueprints.uploadingMediaToFB
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchAccounts: (0, _redux.bindActionCreators)(_actions.fetchAccounts, dispatch),
	    onUpload: (0, _redux.bindActionCreators)(_actions.uploadMediaToFacebook, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PreviewBlueprints2.default);

/***/ },

/***/ 3885:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _components = __webpack_require__(3886);
	
	var _Blueprint = __webpack_require__(3891);
	
	__webpack_require__(3911);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreviewBlueprints = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(PreviewBlueprints, _Component);
	
	  function PreviewBlueprints() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PreviewBlueprints);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreviewBlueprints.__proto__ || (0, _getPrototypeOf2.default)(PreviewBlueprints)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      accounts: {
	        loading: false,
	        data: []
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PreviewBlueprints, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          blueprints = _props.blueprints,
	          accounts = _props.accounts,
	          onUpload = _props.onUpload,
	          fetchAccounts = _props.fetchAccounts,
	          WSSEToken = _props.WSSEToken,
	          mediaFBActionUrl = _props.mediaFBActionUrl,
	          uploadingMediaToFB = _props.uploadingMediaToFB;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'PreviewBlueprints__Component' },
	        _react2.default.createElement(
	          _components.Header,
	          null,
	          'Blueprints'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            _antd.Spin,
	            { spinning: loading, style: { marginTop: '100px' } },
	            _react2.default.createElement(_components.Blueprint, {
	              blueprints: blueprints,
	              admin: false,
	              onUpload: onUpload,
	              fetchAccounts: fetchAccounts,
	              accounts: accounts,
	              WSSEToken: WSSEToken,
	              mediaFBActionUrl: mediaFBActionUrl,
	              uploadingMediaToFB: uploadingMediaToFB
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return PreviewBlueprints;
	}(_react.Component), _class.propTypes = {
	  loading: _propTypes2.default.bool.isRequired,
	  onUpload: _propTypes2.default.func.isRequired,
	  fetchAccounts: _propTypes2.default.func.isRequired,
	  blueprints: _Blueprint.BlueprintPropTypes.blueprints,
	  accounts: _Blueprint.BlueprintPropTypes.accounts,
	  mediaFBActionUrl: _propTypes2.default.string,
	  WSSEToken: _propTypes2.default.string,
	  uploadingMediaToFB: _propTypes2.default.bool
	}, _class.defaultProps = {
	  fetchAccounts: function fetchAccounts() {},
	  blueprints: [],
	  accounts: {
	    loading: false,
	    data: []
	  },
	  mediaFBActionUrl: '',
	  WSSEToken: '',
	  uploadingMediaToFB: false
	}, _temp2);
	exports.default = PreviewBlueprints;

/***/ },

/***/ 3886:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionIcons = __webpack_require__(3887);
	
	Object.defineProperty(exports, 'ActionIcons', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActionIcons).default;
	  }
	});
	
	var _EditableCell = __webpack_require__(3889);
	
	Object.defineProperty(exports, 'EditableCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableCell).default;
	  }
	});
	
	var _Blueprint = __webpack_require__(3891);
	
	Object.defineProperty(exports, 'Blueprint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Blueprint).default;
	  }
	});
	
	var _BlueprintModal = __webpack_require__(3903);
	
	Object.defineProperty(exports, 'BlueprintModal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlueprintModal).default;
	  }
	});
	
	var _Header = __webpack_require__(3905);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _LayerInputFields = __webpack_require__(3907);
	
	Object.defineProperty(exports, 'LayerInputFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LayerInputFields).default;
	  }
	});
	
	var _PreviewModal = __webpack_require__(3909);
	
	Object.defineProperty(exports, 'PreviewModal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PreviewModal).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ 3887:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _antd = __webpack_require__(781);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _picasso = __webpack_require__(3888);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionIcons = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(ActionIcons, _Component);
	
	  function ActionIcons() {
	    (0, _classCallCheck3.default)(this, ActionIcons);
	    return (0, _possibleConstructorReturn3.default)(this, (ActionIcons.__proto__ || (0, _getPrototypeOf2.default)(ActionIcons)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ActionIcons, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (nextProps.previewState === this.props.previewState) return false;
	
	      return true;
	    }
	  }, {
	    key: 'buildPreviewIcon',
	    value: function buildPreviewIcon() {
	      var _props = this.props,
	          _props$previewState = _props.previewState,
	          previewState = _props$previewState === undefined ? {} : _props$previewState,
	          _props$onGeneratePrev = _props.onGeneratePreview,
	          onGeneratePreview = _props$onGeneratePrev === undefined ? function () {} : _props$onGeneratePrev,
	          _props$onViewPreview = _props.onViewPreview,
	          onViewPreview = _props$onViewPreview === undefined ? function () {} : _props$onViewPreview;
	
	      if (previewState === _picasso.PREVIEW_STATES.PREVIEW_ERROR) return _react2.default.createElement(_antd.Icon, { type: 'close-circle-o', onClick: onGeneratePreview });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_QUEUED) return _react2.default.createElement(_antd.Icon, { type: 'clock-circle-o' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_LOADING || previewState === _picasso.PREVIEW_STATES.PREVIEW_REQUESTING) return _react2.default.createElement(_antd.Icon, { type: 'loading' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_FLASH_COMPLETED) return _react2.default.createElement(_antd.Icon, { type: 'check-circle-o' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_AVAILABLE) return _react2.default.createElement(_antd.Icon, { className: 'available', type: 'eye', onClick: onViewPreview });
	      return _react2.default.createElement(_antd.Icon, { type: 'eye', onClick: onGeneratePreview });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$onDelete = _props2.onDelete,
	          onDelete = _props2$onDelete === undefined ? function () {} : _props2$onDelete,
	          _props2$onDuplicate = _props2.onDuplicate,
	          onDuplicate = _props2$onDuplicate === undefined ? function () {} : _props2$onDuplicate,
	          _props2$previewToolti = _props2.previewTooltip,
	          previewTooltip = _props2$previewToolti === undefined ? "" : _props2$previewToolti;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            { onClick: onDelete },
	            _react2.default.createElement(
	              _antd.Tooltip,
	              { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'GenerateVariations.table.operation.delete.label', defaultMessage: 'Delete' }) },
	              _react2.default.createElement(_antd.Icon, { type: 'delete' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            { onClick: onDuplicate },
	            _react2.default.createElement(
	              _antd.Tooltip,
	              { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'GenerateVariations.table.operation.duplicate.label', defaultMessage: 'Duplicate' }) },
	              _react2.default.createElement(_antd.Icon, { type: 'copy' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'preview-icon-container' },
	            _react2.default.createElement(
	              _antd.Tooltip,
	              { title: previewTooltip },
	              this.buildPreviewIcon()
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ActionIcons;
	}(_react.Component), _class.propTypes = {
	  previewState: _propTypes2.default.string.isRequired,
	  previewTooltip: _propTypes2.default.string.isRequired,
	  onGeneratePreview: _propTypes2.default.func.isRequired,
	  onViewPreview: _propTypes2.default.func.isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  onDuplicate: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = ActionIcons;

/***/ },

/***/ 3888:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setPreviewUrls = exports.unsetPreviewFlashCompleted = exports.setPreviewFlashCompleted = exports.setPreviewError = exports.setPreviewId = exports.unsetPreviewQueued = exports.setPreviewQueued = exports.startPreviewRequest = exports.determinePreviewState = exports.PREVIEW_STATES = undefined;
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _omit = __webpack_require__(1811);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PREVIEW_STATES = exports.PREVIEW_STATES = {
	  PREVIEW_REQUESTABLE: "PREVIEW_REQUESTABLE",
	  PREVIEW_REQUESTING: "PREVIEW_REQUESTING", // requesting preview model from picasso
	  PREVIEW_QUEUED: "PREVIEW_QUEUED", // got preview model from picasso, but job hasn't started processing yet
	  PREVIEW_ERROR: "PREVIEW_ERROR", // Error occurred from Picasso
	  PREVIEW_LOADING: "PREVIEW_LOADING", // Have a preview id, but waiting for Picasso to proccess the preview job
	  PREVIEW_FLASH_COMPLETED: "PREVIEW_FLASH_COMPLETED", // state for when we retrieve that the preview is finished for the first time (mainly used to flash completed feedback to user)
	  PREVIEW_AVAILABLE: "PREVIEW_AVAILABLE" // preview image urls are available to be viewed
	};
	
	var determinePreviewState = exports.determinePreviewState = function determinePreviewState() {
	  var previewObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  if (!previewObj) return PREVIEW_STATES.PREVIEW_REQUESTABLE;
	
	  if (previewObj.error) return PREVIEW_STATES.PREVIEW_ERROR;else if (previewObj.previewQueued) return PREVIEW_STATES.PREVIEW_QUEUED;else if (previewObj.requestingPreview) return PREVIEW_STATES.PREVIEW_REQUESTING;else if (previewObj.flashCompleted) return PREVIEW_STATES.PREVIEW_FLASH_COMPLETED;else if (previewObj.previewUrls) return PREVIEW_STATES.PREVIEW_AVAILABLE;
	
	  return PREVIEW_STATES.PREVIEW_LOADING;
	};
	
	// These function help update the `preview` object on each dataSource variation row
	var startPreviewRequest = exports.startPreviewRequest = function startPreviewRequest() {
	  return {
	    requestingPreview: true
	  };
	};
	
	var setPreviewQueued = exports.setPreviewQueued = function setPreviewQueued(previewObj, previewId) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'setPreviewQueued'"
	    });
	  }
	
	  return (0, _assign2.default)({}, previewObj, { previewQueued: true });
	};
	
	var unsetPreviewQueued = exports.unsetPreviewQueued = function unsetPreviewQueued(previewObj, previewId) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'unsetPreviewQueued'"
	    });
	  }
	
	  return (0, _omit2.default)(previewObj, ["previewQueued"]);
	};
	
	var setPreviewId = exports.setPreviewId = function setPreviewId(previewObj, previewId) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'setPreviewId'"
	    });
	  }
	
	  return (0, _assign2.default)({}, previewObj, { id: previewId, requestingPreview: false });
	};
	
	var setPreviewError = exports.setPreviewError = function setPreviewError(previewObj, error) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'setPreviewError'"
	    });
	  }
	
	  return (0, _assign2.default)({}, previewObj, { error: error, requestingPreview: false });
	};
	
	var setPreviewFlashCompleted = exports.setPreviewFlashCompleted = function setPreviewFlashCompleted(previewObj) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'setPreviewFlashCompleted'"
	    });
	  }
	
	  return (0, _assign2.default)({}, previewObj, { flashCompleted: true });
	};
	
	var unsetPreviewFlashCompleted = exports.unsetPreviewFlashCompleted = function unsetPreviewFlashCompleted(previewObj) {
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'unsetPreviewFlashCompleted'"
	    });
	  }
	
	  return (0, _omit2.default)(previewObj, ["flashCompleted"]);
	};
	
	var setPreviewUrls = exports.setPreviewUrls = function setPreviewUrls(previewObj) {
	  var urls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (!previewObj) {
	    throw (0, _assign2.default)({
	      title: "Error",
	      message: "previewObj must be passed to function 'setPreviewUrls'"
	    });
	  }
	
	  return (0, _assign2.default)({}, previewObj, { previewUrls: urls });
	};

/***/ },

/***/ 3889:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /* eslint-disable react/no-array-index-key */
	
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _generic = __webpack_require__(1666);
	
	__webpack_require__(3890);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Option = _antd.Select.Option;
	
	var isNotificationDisplayed = false;
	
	var EditableCell = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(EditableCell, _Component);
	
	  function EditableCell() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EditableCell);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditableCell.__proto__ || (0, _getPrototypeOf2.default)(EditableCell)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fileList: []
	    }, _this.handleChange = function (value) {
	      if (_this.props.onChange) {
	        _this.props.onChange(value);
	      }
	    }, _this.buildInputField = function () {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          validators = _this$props.validators,
	          placeholder = _this$props.placeholder;
	
	      var characterCountValidator = validators.find(function (validator) {
	        return validator.type === 'CHARACTER_COUNT_VALIDATOR';
	      });
	
	      var suffix = null;
	      var characterLimit = null;
	      var handleInputChange = function handleInputChange(value) {
	        return _this.handleChange(value);
	      };
	      var characterCountClassName = '';
	
	      if (characterCountValidator) {
	        characterLimit = parseInt(characterCountValidator.args[0], 10);
	        suffix = value.length + '/' + characterLimit;
	        characterCountClassName = value.length >= characterLimit ? 'has-warning' : '';
	      }
	
	      return _react2.default.createElement(_antd.Input, {
	        value: value || '',
	        onChange: function onChange(e) {
	          return handleInputChange(e.target.value);
	        },
	        suffix: suffix,
	        style: { width: '100%' },
	        placeholder: 'Enter ' + placeholder,
	        className: 'EditableCell-input-box ' + characterCountClassName
	      });
	    }, _this.buildColourSelectField = function () {
	      var _this$props2 = _this.props,
	          validators = _this$props2.validators,
	          value = _this$props2.value,
	          placeholder = _this$props2.placeholder;
	
	      var options = validators[0].args.map(function (item, index) {
	        return _react2.default.createElement(
	          Option,
	          { key: index, value: item },
	          _react2.default.createElement('span', {
	            className: 'EditableCell-colour-box',
	            style: { backgroundColor: '#' + item }
	          }),
	          item
	        );
	      });
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          value: value === '' ? undefined : value,
	          placeholder: 'Select ' + placeholder,
	          style: { width: '100%' },
	          onChange: _this.handleChange
	        },
	        options
	      );
	    }, _this.buildMediaSelectField = function () {
	      var _this$props3 = _this.props,
	          validators = _this$props3.validators,
	          contentType = _this$props3.contentType,
	          value = _this$props3.value,
	          placeholder = _this$props3.placeholder,
	          enableUserMedia = _this$props3.enableUserMedia;
	
	
	      var handleMediaChange = function handleMediaChange(_ref2) {
	        var fileList = _ref2.fileList;
	
	        if (!isNotificationDisplayed) {
	          _antd.message.loading('Uploading content...');
	          isNotificationDisplayed = true;
	          setTimeout(function () {
	            isNotificationDisplayed = false;
	          }, 2000);
	        }
	        _this.setState({
	          fileList: fileList
	        }, function () {
	          if (_this.state.fileList.every(function (item) {
	            return item.status === "done";
	          })) {
	            _this.props.addCustomMediaAsset(_this.state.fileList);
	            _this.setState({
	              fileList: []
	            });
	          }
	        });
	      };
	
	      var options = validators[0].args.map(function (item, index) {
	        return _react2.default.createElement(
	          Option,
	          { key: index, value: item },
	          contentType === 'IMAGE' && _react2.default.createElement(
	            _antd.Tooltip,
	            { key: index, placement: 'topRight', title: _react2.default.createElement('img', { src: item, style: { maxHeight: 300, maxWidth: 200 }, alt: 'Media ' + index }) },
	            _react2.default.createElement('img', {
	              className: 'EditableCell-image-box',
	              src: item,
	              alt: 'Media ' + index
	            })
	          ),
	          (0, _generic.getImageNameFromURL)(item)
	        );
	      });
	
	      var selectStyleWidth = enableUserMedia ? { width: '70%' } : { width: '100%' };
	      var selectClassName = enableUserMedia ? 'select-media-button' : '';
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _antd.Select,
	          {
	            className: selectClassName,
	            value: value === '' ? undefined : value,
	            placeholder: 'Select ' + placeholder,
	            style: selectStyleWidth,
	            onChange: _this.handleChange
	          },
	          options
	        ),
	        enableUserMedia && _react2.default.createElement(
	          _antd.Upload,
	          {
	            accept: (0, _generic.determineAcceptedAttributes)(contentType),
	            action: _this.props.mediaActionUrl,
	            customRequest: function customRequest(option) {
	              return (0, _generic.upload)(option, _this.props.WSSEToken);
	            },
	            name: 'mediaFiles',
	            fileList: _this.state.fileList,
	            onChange: handleMediaChange,
	            multiple: true,
	            showUploadList: false
	          },
	          _react2.default.createElement(
	            _antd.Button,
	            { className: 'add-media-button' },
	            _react2.default.createElement(_antd.Icon, { type: 'upload' })
	          )
	        )
	      );
	    }, _this.buildFields = function () {
	      var contentType = _this.props.contentType;
	
	      switch (contentType) {
	        case 'COLOR':
	          return _this.buildColourSelectField();
	        // TODO: Video & Image should both be extracted out into their own methods
	        case 'VIDEO':
	        case 'IMAGE':
	          return _this.buildMediaSelectField();
	        case 'TEXT':
	          return _this.buildInputField();
	        default:
	          return 'Error, Unknown Field';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EditableCell, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.enableUserMedia === true) return true;else if (this.props.value === nextProps.value) return false;
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'EditableCell__Component' },
	        this.buildFields()
	      );
	    }
	  }]);
	  return EditableCell;
	}(_react.Component), _class.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  contentType: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.string,
	  validators: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  placeholder: _propTypes2.default.string.isRequired,
	  WSSEToken: _propTypes2.default.string,
	  mediaActionUrl: _propTypes2.default.string,
	  addCustomMediaAsset: _propTypes2.default.func.isRequired,
	  enableUserMedia: _propTypes2.default.bool
	}, _class.defaultProps = {
	  value: '',
	  WSSEToken: '',
	  mediaActionUrl: '',
	  enableUserMedia: true
	}, _temp2);
	exports.default = EditableCell;

/***/ },

/***/ 3890:
/***/ function(module, exports) {



/***/ },

/***/ 3891:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlueprintPropTypes = undefined;
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(831);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable react/no-array-index-key */
	
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(717);
	
	var _chunk = __webpack_require__(3892);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _escapeRegExp = __webpack_require__(3893);
	
	var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);
	
	var _capitalize = __webpack_require__(3894);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _immutabilityHelper = __webpack_require__(1644);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _antd = __webpack_require__(781);
	
	var _generic = __webpack_require__(1666);
	
	__webpack_require__(3902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Search = _antd.Input.Search;
	var FormItem = _antd.Form.Item;
	
	var BlueprintPropTypes = exports.BlueprintPropTypes = {
	  admin: _propTypes2.default.bool.isRequired,
	  fetchAccounts: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func,
	  onUpload: _propTypes2.default.func,
	  onDuplicate: _propTypes2.default.func,
	  form: _propTypes2.default.shape({
	    getFieldValue: _propTypes2.default.func.isRequired,
	    getFieldDecorator: _propTypes2.default.func.isRequired,
	    getFieldError: _propTypes2.default.func.isRequired,
	    setFieldsValue: _propTypes2.default.func.isRequired,
	    setFieldsInitialValue: _propTypes2.default.func.isRequired,
	    isFieldsTouched: _propTypes2.default.func.isRequired,
	    validateFields: _propTypes2.default.func.isRequired,
	    resetFields: _propTypes2.default.func.isRequired
	  }).isRequired,
	  blueprints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired,
	    previewUrl: _propTypes2.default.string,
	    name: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string
	  })).isRequired,
	  accounts: _propTypes2.default.shape({
	    loading: _propTypes2.default.bool,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	  }),
	  mediaFBActionUrl: _propTypes2.default.string,
	  WSSEToken: _propTypes2.default.string,
	  uploadingMediaToFB: _propTypes2.default.bool
	};
	
	var Blueprint = (_dec = _antd.Form.create(), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(Blueprint, _Component);
	
	  function Blueprint() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Blueprint);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Blueprint.__proto__ || (0, _getPrototypeOf2.default)(Blueprint)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      blueprints: [],
	      modalVisible: false,
	      accounts: {
	        loading: false,
	        data: []
	      },
	      mediaType: "IMAGE",
	      fileList: [],
	      uploading: false
	    }, _this.filterBlueprint = function (searchValue) {
	      if (searchValue !== '') {
	        var blueprints = _this.props.blueprints;
	
	        var reg = new RegExp((0, _escapeRegExp2.default)(searchValue), 'gi');
	        var updatedRuleset = blueprints.map(function (record) {
	          var match = record.name.match(reg);
	          if (!match) return null;
	          return record;
	        }).filter(function (record) {
	          return !!record;
	        });
	        _this.setState({
	          blueprints: (0, _immutabilityHelper2.default)({}, { $set: updatedRuleset })
	        });
	      } else {
	        _this.setState({
	          blueprints: _this.props.blueprints
	        });
	      }
	    }, _this.deleteBlueprint = function (id) {
	      if (_this.props.onDelete) {
	        _this.props.onDelete(id);
	      }
	    }, _this.onDuplicate = function (id) {
	      if (_this.props.onDuplicate) {
	        _this.props.onDuplicate(id);
	      }
	    }, _this.buildBlueprints = function () {
	      var admin = _this.props.admin;
	      var blueprints = _this.state.blueprints;
	
	      var columns = blueprints.map(function (blueprint) {
	        return _react2.default.createElement(
	          _antd.Col,
	          { span: 8, key: blueprint.id },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/creative_at_scale/generate/' + blueprint.id },
	            _react2.default.createElement(
	              _antd.Card,
	              { className: 'card', bodyStyle: { padding: 0 } },
	              _react2.default.createElement(
	                'div',
	                { className: 'custom-image' },
	                _react2.default.createElement('img', { alt: 'example', width: '100%', src: blueprint.previewUrl })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'custom-card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'custom-card-info' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    blueprint.name
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _capitalize2.default)(blueprint.type),
	                    ' Blueprint'
	                  )
	                ),
	                admin && _react2.default.createElement(
	                  'div',
	                  { className: 'custom-card-actions' },
	                  _react2.default.createElement(
	                    _antd.Tooltip,
	                    { title: 'Duplicate Blueprint', placement: 'top' },
	                    _react2.default.createElement(
	                      _antd.Popconfirm,
	                      {
	                        title: 'Duplicate this Blueprint?',
	                        onConfirm: function onConfirm() {
	                          return _this.onDuplicate(blueprint.id);
	                        }
	                      },
	                      _react2.default.createElement(_antd.Icon, { type: 'copy' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Tooltip,
	                    { title: 'Edit Blueprint' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/creative_at_scale/create_blueprint/' + blueprint.id },
	                      _react2.default.createElement(_antd.Icon, { type: 'edit' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Tooltip,
	                    { title: 'Delete Blueprint', placement: 'right' },
	                    _react2.default.createElement(
	                      _antd.Popconfirm,
	                      {
	                        title: 'Delete this Blueprint?',
	                        onConfirm: function onConfirm() {
	                          return _this.deleteBlueprint(blueprint.id);
	                        }
	                      },
	                      _react2.default.createElement(_antd.Icon, { type: 'delete' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	
	      var rows = (0, _chunk2.default)(columns, 3);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        rows.map(function (row, index) {
	          return _react2.default.createElement(
	            _antd.Row,
	            { gutter: 16, key: index },
	            [].concat((0, _toConsumableArray3.default)(row))
	          );
	        })
	      );
	    }, _this.handleMediaTypeChange = function (_ref2) {
	      var target = _ref2.target;
	
	      _this.setState({
	        mediaType: target.value,
	        fileList: []
	      });
	    }, _this.handleMediaChange = function (_ref3) {
	      var fileList = _ref3.fileList;
	
	      _this.setState({
	        fileList: fileList,
	        uploading: fileList.filter(function (file) {
	          return file.status === "uploading";
	        }).length > 0
	      });
	    }, _this.normFile = function (e) {
	      if (Array.isArray(e)) {
	        return e;
	      }
	      return e && e.fileList;
	    }, _this.onUpload = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.onUpload(values);
	        }
	      });
	    }, _this.openUploadModal = function () {
	      _this.props.fetchAccounts();
	      _this.toggleModalVisible();
	    }, _this.toggleModalVisible = function () {
	      _this.setState(function (prevState) {
	        return {
	          modalVisible: !prevState.modalVisible,
	          fileList: []
	        };
	      });
	      _this.props.form.resetFields();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Blueprint, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref4) {
	      var blueprints = _ref4.blueprints,
	          uploadingMediaToFB = _ref4.uploadingMediaToFB;
	
	      this.setState((0, _assign2.default)({
	        blueprints: blueprints
	      }, this.props.uploadingMediaToFB && !uploadingMediaToFB ? { modalVisible: false } : null));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          mediaFBActionUrl = _props.mediaFBActionUrl,
	          WSSEToken = _props.WSSEToken,
	          uploadingMediaToFB = _props.uploadingMediaToFB;
	      var _state = this.state,
	          fileList = _state.fileList,
	          mediaType = _state.mediaType,
	          uploading = _state.uploading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Blueprint__Component' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'blueprint-search' },
	            _react2.default.createElement(Search, {
	              placeholder: 'Search Blueprints',
	              style: { width: 200 },
	              onChange: function onChange(e) {
	                return _this2.filterBlueprint(e.target.value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { className: 'upload-to-fb-button', type: 'primary', onClick: this.openUploadModal },
	            'Upload to Facebook'
	          )
	        ),
	        this.buildBlueprints(),
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: 'Upload to Facebook',
	            visible: this.state.modalVisible,
	            closable: true,
	            onCancel: uploadingMediaToFB ? null : this.toggleModalVisible,
	            width: 700,
	            wrapClassName: 'UploadToFB__Modal',
	            footer: [_react2.default.createElement(
	              _antd.Button,
	              { disabled: uploadingMediaToFB, key: 'cancel', onClick: this.toggleModalVisible },
	              'Cancel'
	            ), _react2.default.createElement(
	              _antd.Button,
	              { disabled: uploading, loading: uploadingMediaToFB, key: 'upload', onClick: this.onUpload, type: 'primary' },
	              'Upload'
	            )]
	          },
	          _react2.default.createElement(
	            _antd.Form,
	            { layout: 'vertical' },
	            _react2.default.createElement(
	              _antd.Row,
	              { gutter: 24 },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  {
	                    label: 'Media Type'
	                  },
	                  getFieldDecorator('mediaType', {
	                    initialValue: 'IMAGE'
	                  })(_react2.default.createElement(
	                    _antd.Radio.Group,
	                    { onChange: this.handleMediaTypeChange },
	                    _react2.default.createElement(
	                      _antd.Radio.Button,
	                      { value: 'IMAGE' },
	                      'Image'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio.Button,
	                      { value: 'VIDEO' },
	                      'Video'
	                    )
	                  ))
	                ),
	                _react2.default.createElement(
	                  FormItem,
	                  {
	                    label: 'Account ID'
	                  },
	                  _react2.default.createElement(
	                    _antd.Spin,
	                    { spinning: this.props.accounts.loading },
	                    getFieldDecorator('account_id', {
	                      rules: [{ required: true, message: 'Account ID is a required Field' }]
	                    })(_react2.default.createElement(
	                      _antd.Select,
	                      {
	                        placeholder: 'Select an account',
	                        showSearch: true,
	                        style: { width: '100%' },
	                        optionFilterProp: 'children',
	                        filterOption: function filterOption(input, option) {
	                          return option.props.searchValue.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                        },
	                        notFoundContent: 'Not Found'
	                      },
	                      this.props.accounts.data.map(function (account) {
	                        return _react2.default.createElement(
	                          _antd.Select.Option,
	                          { searchValue: account.name, key: account.name, value: '' + account.account_id },
	                          account.name || account.account_id
	                        );
	                      })
	                    ))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  {
	                    label: 'Media',
	                    style: { marginBottom: 0 }
	                  },
	                  getFieldDecorator('media', {
	                    getValueFromEvent: this.normFile,
	                    rules: [{ required: true, message: 'Media is a required Field' }]
	                  })(_react2.default.createElement(
	                    _antd.Upload,
	                    {
	                      accept: (0, _generic.determineAcceptedAttributes)(mediaType),
	                      action: mediaFBActionUrl,
	                      customRequest: function customRequest(options) {
	                        return (0, _generic.upload)(options, WSSEToken);
	                      },
	                      name: 'mediaFiles',
	                      fileList: fileList,
	                      onChange: this.handleMediaChange,
	                      multiple: true
	                    },
	                    _react2.default.createElement(
	                      _antd.Button,
	                      { type: 'dashed', className: 'add-media-button' },
	                      _react2.default.createElement(_antd.Icon, { type: 'upload' }),
	                      ' Upload Media'
	                    )
	                  ))
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Blueprint;
	}(_react.Component), _class2.propTypes = BlueprintPropTypes, _class2.defaultProps = {
	  fetchAccounts: function fetchAccounts() {},
	  onDelete: function onDelete() {},
	  onUpload: function onUpload() {},
	  onDuplicate: function onDuplicate() {},
	  accounts: [],
	  mediaFBActionUrl: '',
	  WSSEToken: '',
	  uploadingMediaToFB: false
	}, _temp2)) || _class);
	exports.default = Blueprint;

/***/ },

/***/ 3892:
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1860),
	    isIterateeCall = __webpack_require__(2350),
	    toInteger = __webpack_require__(2335);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array == null ? 0 : array.length;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ },

/***/ 3893:
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(1207);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ },

/***/ 3894:
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(1207),
	    upperFirst = __webpack_require__(3895);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ },

/***/ 3895:
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(3896);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },

/***/ 3896:
/***/ function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(3897),
	    hasUnicode = __webpack_require__(3898),
	    stringToArray = __webpack_require__(3899),
	    toString = __webpack_require__(1207);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },

/***/ 3897:
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1860);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },

/***/ 3898:
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },

/***/ 3899:
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(3900),
	    hasUnicode = __webpack_require__(3898),
	    unicodeToArray = __webpack_require__(3901);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },

/***/ 3900:
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },

/***/ 3901:
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },

/***/ 3902:
/***/ function(module, exports) {



/***/ },

/***/ 3903:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(783);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _generic = __webpack_require__(1666);
	
	__webpack_require__(3904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	var BlueprintModal = (_dec = _antd.Form.create(), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(BlueprintModal, _Component);
	
	  function BlueprintModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BlueprintModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BlueprintModal.__proto__ || (0, _getPrototypeOf2.default)(BlueprintModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      thumbnailFileList: [],
	      guideFileList: [],
	      aeFileList: []
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      var visible = nextProps.visible,
	          blueprint = nextProps.blueprint;
	
	
	      if (!_this.props.visible && visible && blueprint) {
	        _this.setState({
	          thumbnailFileList: blueprint.thumbnailFileList ? blueprint.thumbnailFileList : [],
	          guideFileList: blueprint.guideFileList ? blueprint.guideFileList : [],
	          aeFileList: blueprint.aeFileList ? blueprint.aeFileList : []
	        });
	      }
	    }, _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	      _this.setState({
	        thumbnailFileList: [],
	        guideFileList: [],
	        aeFileList: []
	      });
	    }, _this.onSubmit = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.onSubmit(values);
	        }
	      });
	    }, _this.normFile = function (e) {
	      if (Array.isArray(e)) {
	        return e;
	      }
	      return e && e.fileList;
	    }, _this.handleChange = function (fileList, key) {
	      _this.setState((0, _defineProperty3.default)({}, key, fileList));
	    }, _this.uploadImageView = function (type) {
	      var subText = type === 'Thumbnail' ? 'This could be a brand logo or ad sample' : 'This shows the user what layers can be changed on the Blueprint';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Icon, { type: 'plus' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ant-upload-text' },
	          'Upload Blueprint ',
	          type
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ant-upload-sub-text' },
	          subText
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BlueprintModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          visible = _props.visible,
	          loading = _props.loading,
	          WSSEToken = _props.WSSEToken,
	          mediaActionURLForThumbnails = _props.mediaActionURLForThumbnails,
	          mediaActionURLForGuides = _props.mediaActionURLForGuides,
	          mediaActionURLForAeFiles = _props.mediaActionURLForAeFiles;
	
	
	      var submitText = this.props.blueprint ? "Submit" : "Next";
	      var blueprint = this.props.blueprint || {};
	
	      var _state = this.state,
	          thumbnailFileList = _state.thumbnailFileList,
	          guideFileList = _state.guideFileList,
	          aeFileList = _state.aeFileList;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: 'Create Blueprint',
	          visible: visible,
	          closable: true,
	          onCancel: loading ? null : this.onCancel,
	          width: 700,
	          wrapClassName: 'CreateBlueprints__Modal',
	          footer: [_react2.default.createElement(
	            _antd.Button,
	            { disabled: loading, key: 'cancel', onClick: this.onCancel },
	            'Cancel'
	          ), _react2.default.createElement(
	            _antd.Button,
	            { loading: loading, key: 'next', onClick: this.onSubmit, type: 'primary' },
	            submitText
	          )]
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'vertical' },
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 24 },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                {
	                  label: 'Blueprint Name'
	                },
	                getFieldDecorator('name', {
	                  initialValue: blueprint.name || "",
	                  rules: [{ required: true, message: 'Please input blueprint name' }]
	                })(_react2.default.createElement(_antd.Input, { placeholder: 'Name' }))
	              ),
	              _react2.default.createElement(
	                FormItem,
	                {
	                  label: 'Blueprint Type'
	                },
	                getFieldDecorator('type', {
	                  initialValue: blueprint.type || 'VIDEO'
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Radio.Button,
	                    { value: 'VIDEO' },
	                    'Video'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio.Button,
	                    { value: 'IMAGE' },
	                    'Image'
	                  )
	                ))
	              ),
	              _react2.default.createElement(
	                FormItem,
	                {
	                  label: 'After Effects Package'
	                },
	                getFieldDecorator('aeFile', {
	                  initialValue: blueprint.aeFileList || [],
	                  getValueFromEvent: this.normFile
	                })(_react2.default.createElement(
	                  _antd.Upload,
	                  {
	                    accept: 'application/zip',
	                    action: mediaActionURLForAeFiles,
	                    customRequest: function customRequest(options) {
	                      return (0, _generic.upload)(options, WSSEToken);
	                    },
	                    fileList: aeFileList,
	                    onChange: function onChange(_ref2) {
	                      var fileList = _ref2.fileList;
	                      return _this2.handleChange(fileList, 'aeFileList');
	                    }
	                  },
	                  aeFileList.length >= 1 ? null : _react2.default.createElement(
	                    _antd.Button,
	                    null,
	                    _react2.default.createElement(_antd.Icon, { type: 'upload' }),
	                    ' Click to Upload'
	                  )
	                ))
	              ),
	              _react2.default.createElement(
	                FormItem,
	                {
	                  label: 'Description',
	                  style: { marginBottom: 0 }
	                },
	                getFieldDecorator('description', {
	                  initialValue: blueprint.description || ""
	                })(_react2.default.createElement(TextArea, {
	                  placeholder: 'Add any comments or instructions here',
	                  autosize: { minRows: 4, maxRows: 4 }
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                _antd.Row,
	                { gutter: 24 },
	                _react2.default.createElement(
	                  FormItem,
	                  {
	                    style: { marginBottom: 0 }
	                  },
	                  getFieldDecorator('thumbnailImage', {
	                    initialValue: blueprint.thumbnailFileList || [],
	                    getValueFromEvent: this.normFile
	                  })(_react2.default.createElement(
	                    _antd.Upload,
	                    {
	                      accept: 'image/*',
	                      action: mediaActionURLForThumbnails,
	                      customRequest: function customRequest(options) {
	                        return (0, _generic.upload)(options, WSSEToken);
	                      },
	                      listType: 'picture-card',
	                      fileList: thumbnailFileList,
	                      onChange: function onChange(_ref3) {
	                        var fileList = _ref3.fileList;
	                        return _this2.handleChange(fileList, 'thumbnailFileList');
	                      },
	                      showUploadList: { showPreviewIcon: false, showRemoveIcon: true }
	                    },
	                    thumbnailFileList.length >= 1 ? null : this.uploadImageView('Thumbnail')
	                  ))
	                ),
	                _react2.default.createElement(
	                  FormItem,
	                  {
	                    style: { marginBottom: 0 }
	                  },
	                  getFieldDecorator('guideImage', {
	                    initialValue: blueprint.guideFileList || [],
	                    getValueFromEvent: this.normFile
	                  })(_react2.default.createElement(
	                    _antd.Upload,
	                    {
	                      accept: 'image/*',
	                      action: mediaActionURLForGuides,
	                      customRequest: function customRequest(options) {
	                        return (0, _generic.upload)(options, WSSEToken);
	                      },
	                      listType: 'picture-card',
	                      fileList: guideFileList,
	                      onChange: function onChange(_ref4) {
	                        var fileList = _ref4.fileList;
	                        return _this2.handleChange(fileList, 'guideFileList');
	                      },
	                      showUploadList: { showPreviewIcon: false, showRemoveIcon: true }
	                    },
	                    guideFileList.length >= 1 ? null : this.uploadImageView('Guide')
	                  ))
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return BlueprintModal;
	}(_react.Component), _class2.propTypes = {
	  form: _propTypes2.default.shape({
	    getFieldValue: _propTypes2.default.func.isRequired,
	    getFieldDecorator: _propTypes2.default.func.isRequired,
	    getFieldError: _propTypes2.default.func.isRequired,
	    setFieldsValue: _propTypes2.default.func.isRequired,
	    setFieldsInitialValue: _propTypes2.default.func.isRequired,
	    isFieldsTouched: _propTypes2.default.func.isRequired,
	    validateFields: _propTypes2.default.func.isRequired,
	    resetFields: _propTypes2.default.func.isRequired
	  }).isRequired,
	  blueprint: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    layerTemplates: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      title: _propTypes2.default.string.isRequired,
	      contentType: _propTypes2.default.string.isRequired,
	      validators: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	    }))
	  }).isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  mediaActionURLForThumbnails: _propTypes2.default.string.isRequired,
	  mediaActionURLForGuides: _propTypes2.default.string.isRequired,
	  mediaActionURLForAeFiles: _propTypes2.default.string.isRequired,
	  WSSEToken: _propTypes2.default.string.isRequired
	}, _temp2)) || _class);
	exports.default = BlueprintModal;

/***/ },

/***/ 3904:
/***/ function(module, exports) {



/***/ },

/***/ 3905:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(3906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(Header, _Component);
	
	  function Header() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Header__Component' },
	        this.props.children
	      );
	    }
	  }]);
	  return Header;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node.isRequired
	}, _class.defaultProps = {}, _temp2);
	exports.default = Header;

/***/ },

/***/ 3906:
/***/ function(module, exports) {



/***/ },

/***/ 3907:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(783);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	var _immutabilityHelper = __webpack_require__(1644);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _generic = __webpack_require__(1666);
	
	__webpack_require__(3908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerInputFields = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(LayerInputFields, _Component);
	
	  function LayerInputFields() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LayerInputFields);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LayerInputFields.__proto__ || (0, _getPrototypeOf2.default)(LayerInputFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      count: 1,
	      colours: [{
	        id: 1,
	        hex: ''
	      }],
	      fileList: [],
	      tooltipText: '',
	      characterCount: 1,
	      enableUserMedia: false
	
	      // NOTE: until we update to react 16+, we need to have this in place.
	      // React 16+ provides getderivedstatefromprops (https://reactjs.org/docs/react-component.html#static-getderivedstatefromprops)
	      // which allows us to update state from props. Currently we have to do it in componentDidMount
	      // which causes an extra render.
	      /* eslint-disable react/no-did-mount-set-state */
	    }, _this.buildColourInputFields = function () {
	      var disableFields = _this.props.disableFields;
	
	
	      var addColour = function addColour() {
	        var _this$state = _this.state,
	            colours = _this$state.colours,
	            count = _this$state.count;
	
	        var updatedCount = count + 1;
	        _this.setState({
	          count: updatedCount,
	          colours: (0, _immutabilityHelper2.default)(colours, {
	            $push: [{
	              id: updatedCount,
	              hex: ''
	            }]
	          })
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours');
	        });
	      };
	      var deleteColour = function deleteColour(id) {
	        var colours = _this.state.colours;
	
	        var splicedColours = colours.filter(function (colour) {
	          return colour.id !== id;
	        });
	        _this.setState({
	          colours: (0, _immutabilityHelper2.default)(colours, {
	            $set: splicedColours
	          })
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours', _this.state.colours.length === 0);
	        });
	      };
	      var updateColourFieldValue = function updateColourFieldValue(id, value) {
	        var colours = _this.state.colours;
	
	        _this.setState({
	          colours: (0, _immutabilityHelper2.default)(colours, (0, _defineProperty3.default)({}, colours.findIndex(function (color) {
	            return color.id === id;
	          }), { $merge: {
	              hex: value
	            } }))
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours');
	        });
	      };
	      var buildColourInputs = function buildColourInputs() {
	        var colours = _this.state.colours;
	
	        return colours.map(function (colour) {
	          return _react2.default.createElement(
	            'div',
	            { key: colour.id, className: 'box' },
	            _react2.default.createElement('span', {
	              className: 'colour-box',
	              style: { backgroundColor: colour.hex.includes('#') ? colour.hex : '#' + colour.hex }
	            }),
	            _react2.default.createElement(_antd.Input, {
	              disabled: disableFields,
	              className: 'colour-input-box',
	              style: { marginBottom: '10px' },
	              value: colour.hex,
	              suffix: disableFields ? null : _react2.default.createElement(_antd.Icon, { type: 'close', onClick: function onClick() {
	                  return deleteColour(colour.id);
	                } }),
	              onChange: function onChange(e) {
	                return updateColourFieldValue(colour.id, e.target.value);
	              }
	            })
	          );
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'colour-inputs' },
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            disabled: disableFields,
	            type: 'dashed',
	            className: 'add-colour-button',
	            onClick: addColour
	          },
	          'Add Colour'
	        ),
	        buildColourInputs()
	      );
	    }, _this.buildMediaInputFields = function () {
	      var disableFields = _this.props.disableFields;
	
	
	      var handleChange = function handleChange(_ref2) {
	        var fileList = _ref2.fileList;
	
	        _this.setState({
	          fileList: fileList
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.fileList, 'media', _this.state.fileList.length === 0);
	        });
	      };
	
	      var toggleUserMediaOnHandle = function toggleUserMediaOnHandle(checked) {
	        _this.setState({
	          enableUserMedia: checked
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.enableUserMedia, 'enableUserMedia', false);
	        });
	      };
	
	      var contentType = _this.props.layer.contentType;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'media-inputs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'enable-user-media' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label-text' },
	            'Enable User Media'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'switch' },
	            _react2.default.createElement(_antd.Switch, {
	              checked: _this.state.enableUserMedia,
	              size: 'small',
	              onChange: toggleUserMediaOnHandle
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Upload,
	          {
	            accept: (0, _generic.determineAcceptedAttributes)(contentType),
	            action: _this.props.mediaActionUrl,
	            customRequest: function customRequest(option) {
	              return (0, _generic.upload)(option, _this.props.WSSEToken);
	            },
	            name: 'mediaFiles',
	            fileList: _this.state.fileList,
	            onChange: handleChange,
	            multiple: true,
	            disabled: disableFields,
	            showUploadList: {
	              showRemoveIcon: !disableFields
	            }
	          },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'dashed', className: 'add-media-button', disabled: disableFields },
	            _react2.default.createElement(_antd.Icon, { type: 'upload' }),
	            ' Upload Media'
	          )
	        )
	      );
	    }, _this.buildTextReadOnlyField = function () {
	      var disableFields = _this.props.disableFields;
	
	      var updateCharacterCount = function updateCharacterCount(value) {
	        _this.setState({
	          characterCount: value
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.characterCount, 'characterCount', false);
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'text-inputs' },
	        _react2.default.createElement(_antd.Input, {
	          className: 'text-box',
	          disabled: true,
	          value: 'Text',
	          suffix: disableFields ? null : _react2.default.createElement(_antd.Icon, { style: { cursor: 'pointer' }, type: 'close', onClick: function onClick() {
	              return _this.props.onChange('', '', true);
	            } })
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'character-count-label' },
	            'Character Count'
	          ),
	          _react2.default.createElement(_antd.InputNumber, {
	            min: 1,
	            value: _this.state.characterCount,
	            onChange: updateCharacterCount,
	            disabled: disableFields
	          })
	        )
	      );
	    }, _this.buildFields = function () {
	      var contentType = _this.props.layer.contentType;
	
	      switch (contentType) {
	        case 'COLOR':
	          return _this.buildColourInputFields();
	        case 'IMAGE':
	        case 'VIDEO':
	        case 'AUDIO':
	          return _this.buildMediaInputFields();
	        case 'TEXT':
	          return _this.buildTextReadOnlyField();
	        default:
	          return 'Error, Unknown Field';
	      }
	    }, _this.buildTooltip = function () {
	      var tooltipText = _this.state.tooltipText;
	
	      var updateTooltip = function updateTooltip(e) {
	        _this.setState({
	          tooltipText: e.target.value
	        }, function () {
	          if (_this.props.onChange) _this.props.onChange(_this.state.tooltipText, 'tooltip', false);
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tooltip-input' },
	        _react2.default.createElement(_antd.Input, {
	          placeholder: 'Instructions, Tips, etc...',
	          value: tooltipText,
	          onChange: updateTooltip
	        })
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LayerInputFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var layer = this.props.layer;
	
	      if (layer && layer.media && layer.media.length !== 0) {
	        this.setState({
	          fileList: layer.media
	        });
	      } else if (layer && layer.colours && layer.colours.length !== 0) {
	        this.setState({
	          colours: layer.colours
	        });
	      }
	      // Update tooltip local state if prop contains it
	      if (layer.tooltip !== '') this.setState({ tooltipText: layer.tooltip });
	      // Update Character Count if prop contains it
	      if (layer.characterCount) this.setState({ characterCount: layer.characterCount });
	
	      if (layer.enableUserMedia) this.setState({ enableUserMedia: layer.enableUserMedia });
	    }
	    /* eslint-enable react/no-did-mount-set-state */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var disableFields = this.props.disableFields;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'LayerInputFields__Component' },
	        this.buildTooltip(),
	        _react2.default.createElement(
	          'div',
	          { className: disableFields ? 'disableds' : '' },
	          this.buildFields()
	        )
	      );
	    }
	  }]);
	  return LayerInputFields;
	}(_react.Component), _class.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  layer: _propTypes2.default.shape({
	    contentType: _propTypes2.default.string.isRequired
	  }).isRequired,
	  WSSEToken: _propTypes2.default.string,
	  mediaActionUrl: _propTypes2.default.string,
	  disableFields: _propTypes2.default.bool.isRequired
	}, _class.defaultProps = {
	  WSSEToken: '',
	  mediaActionUrl: ''
	}, _temp2);
	exports.default = LayerInputFields;

/***/ },

/***/ 3908:
/***/ function(module, exports) {



/***/ },

/***/ 3909:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(781);
	
	__webpack_require__(3910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreviewModal = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(PreviewModal, _Component);
	
	  function PreviewModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PreviewModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreviewModal.__proto__ || (0, _getPrototypeOf2.default)(PreviewModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      imageRatio: 1,
	      loading: true
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (!_this.props.visible && nextProps.visible) {
	        var img = new Image();
	        img.onload = function (e) {
	          var imageRatio = e.target.width / e.target.height;
	          _this.setState({
	            imageRatio: imageRatio,
	            loading: false
	          });
	        };
	        img.src = nextProps.imageUrls[0];
	      }
	    }, _this.componentDidUpdate = function (prevProps, prevState) {
	      if (_this.carouselRef && !prevProps.visible && _this.props.visible) {
	        // HACKY - When closing modal, there seems to be a bug with the innerSlider in Carousel, where it is incorrectly setting currentSlide index
	        // This happens when we change imageUrls to empty (on close). - JT
	        _this.carouselRef.innerSlider.setState({ currentSlide: 0 });
	      }
	    }, _this.buildContent = function () {
	      return _this.props.imageUrls.map(function (url) {
	        return _react2.default.createElement(
	          'div',
	          { key: url },
	          _react2.default.createElement('img', { src: url, alt: 'Preview' })
	        );
	      });
	    }, _this.onCancel = function () {
	      _this.props.onCancel();
	      _this.setState({
	        loading: true
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PreviewModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var visible = this.props.visible;
	
	      var modalHeight = window.innerHeight - 25;
	
	      var modalTopMargin = 20; // margin modal is from top of window
	      var modalPadding = 16 * 2; // padding, both top and bottom of modal
	      var topXIconPadding = 25; // padding within modal to allow for x-icon spacing
	      var modalSidePadding = 32; // padding on the sides of the image
	      var effectiveImageHeight = modalHeight - modalTopMargin - modalPadding - topXIconPadding;
	      if (this.state.loading) return null;
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: 'Preview',
	          visible: visible,
	          onCancel: this.onCancel,
	          closable: true,
	          style: { top: 20 },
	          height: modalHeight,
	          width: effectiveImageHeight * this.state.imageRatio + modalSidePadding,
	          wrapClassName: 'Preview__Modal',
	          footer: null
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'carousel-container' },
	          _react2.default.createElement(
	            _antd.Carousel,
	            {
	              ref: function ref(_ref2) {
	                _this2.carouselRef = _ref2;
	              }
	            },
	            this.buildContent()
	          )
	        )
	      );
	    }
	  }]);
	  return PreviewModal;
	}(_react.Component), _class.propTypes = {
	  imageUrls: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = PreviewModal;

/***/ },

/***/ 3910:
/***/ function(module, exports) {



/***/ },

/***/ 3911:
/***/ function(module, exports) {



/***/ },

/***/ 3912:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildPicassoPreviewSerializer = exports.buildLayerCreatorLocalState = exports.buildBlueprintLocalState = exports.buildMediaActionURLWithID = exports.buildExportJobActionURL = exports.buildMediaFBActionURL = exports.buildMediaActionURLForAeFiles = exports.buildMediaActionURLForGuides = exports.buildMediaActionURLForThumbnails = exports.buildLayerSchemaCascaderOptions = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(1667);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reselect = __webpack_require__(3913);
	
	var _generic = __webpack_require__(1666);
	
	var _serializers = __webpack_require__(3914);
	
	var _constants = __webpack_require__(1662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildFileUploadObj = function buildFileUploadObj(url) {
	  return {
	    uid: (0, _generic.uuidv4)(),
	    name: (0, _generic.getImageNameFromURL)(url),
	    status: 'done',
	    url: url
	  };
	};
	
	var buildLayerSchemaCascaderOptions = exports.buildLayerSchemaCascaderOptions = (0, _reselect.createSelector)(function (state) {
	  return state[_constants.STORE_NAMESPACE].blueprints.layerSchema;
	}, function (layerSchema) {
	  var options = [];
	  var categories = (0, _keys2.default)(layerSchema);
	  categories.forEach(function (layer, parentIndex) {
	    options.push({
	      value: layer,
	      label: layer,
	      children: []
	    });
	    var layers = layerSchema[layer];
	    layers.forEach(function (layer) {
	      options[parentIndex].children.push({
	        label: layer.label,
	        value: layer.contentType
	      });
	    });
	  });
	  return options;
	});
	
	var buildMediaActionURLForThumbnails = exports.buildMediaActionURLForThumbnails = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (paletteAPIURL) {
	  return paletteAPIURL + '/media/upload?subFolder=PREVIEWS';
	});
	
	var buildMediaActionURLForGuides = exports.buildMediaActionURLForGuides = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (paletteAPIURL) {
	  return paletteAPIURL + '/media/upload?subFolder=GUIDES';
	});
	
	var buildMediaActionURLForAeFiles = exports.buildMediaActionURLForAeFiles = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (paletteAPIURL) {
	  return paletteAPIURL + '/media/upload?subFolder=AFTER_EFFECTS';
	});
	
	var buildMediaFBActionURL = exports.buildMediaFBActionURL = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (paletteAPIURL) {
	  return paletteAPIURL + '/media/upload-facebook';
	});
	
	var buildExportJobActionURL = exports.buildExportJobActionURL = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (state) {
	  return state.record.id;
	}, function (paletteAPIURL, id) {
	  return paletteAPIURL + '/export-jobs/' + id + '/upload-zip';
	});
	
	var buildMediaActionURLWithID = exports.buildMediaActionURLWithID = (0, _reselect.createSelector)(function (state) {
	  return state.session.ENDPOINTS.palette_api_url;
	}, function (state) {
	  return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	}, function (paletteAPIURL, blueprint) {
	  if (!paletteAPIURL || !blueprint) return '';
	  return paletteAPIURL + '/media/upload/' + blueprint.id;
	});
	
	var buildBlueprintLocalState = exports.buildBlueprintLocalState = (0, _reselect.createSelector)(function (blueprint) {
	  return blueprint;
	}, function (blueprint) {
	  var parsedBlueprint = (0, _assign2.default)({}, blueprint);
	
	  if (blueprint && blueprint.previewUrl) (0, _assign2.default)(parsedBlueprint, { thumbnailFileList: [buildFileUploadObj(blueprint.previewUrl)] });
	  if (blueprint && blueprint.guideUrl) (0, _assign2.default)(parsedBlueprint, { guideFileList: [buildFileUploadObj(blueprint.guideUrl)] });
	  if (blueprint && blueprint.aeFileUrl) (0, _assign2.default)(parsedBlueprint, { aeFileList: [buildFileUploadObj(blueprint.aeFileUrl)] });
	
	  return parsedBlueprint;
	});
	
	var buildLayerCreatorLocalState = exports.buildLayerCreatorLocalState = (0, _reselect.createSelector)(function (blueprint) {
	  return blueprint;
	}, function (blueprint) {
	  var layerTemplates = blueprint.layerTemplates;
	
	  if (layerTemplates.length === 0) return null;
	  var buildBasedOnContentType = function buildBasedOnContentType(contentType, validators) {
	    switch (contentType) {
	      case 'TEXT':
	        {
	          var validator = validators.find(function (item) {
	            return item.type === 'CHARACTER_COUNT_VALIDATOR';
	          });
	          return {
	            characterCount: validator ? validator.args : 1
	          };
	        }
	      case 'COLOR':
	        return {
	          colours: validators[0].args.map(function (item) {
	            return { id: (0, _generic.uuidv4)(), hex: item };
	          })
	        };
	      case 'VIDEO':
	      case 'IMAGE':
	      case 'AUDIO':
	        return {
	          media: validators[0].args.map(function (item) {
	            return buildFileUploadObj(item);
	          })
	        };
	      default:
	        return null;
	    }
	  };
	
	  return layerTemplates.map(function (item) {
	    return (0, _extends3.default)({
	      id: item.id,
	      contentType: item.contentType,
	      enableTitleEdit: false,
	      title: item.title,
	      tooltip: item.tooltip,
	      enableUserMedia: item.enableUserMedia
	    }, buildBasedOnContentType(item.contentType, item.validators));
	  });
	});
	
	var buildPicassoPreviewSerializer = exports.buildPicassoPreviewSerializer = (0, _reselect.createSelector)(function (state) {
	  return state;
	}, function (state) {
	  return function () {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var blueprint = state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	    var user = state.session.user;
	    return (0, _assign2.default)({}, {
	      blueprintId: blueprint.id,
	      organizationId: blueprint.organizationId,
	      userId: user.id,
	      values: [(0, _serializers.VariationSerializer)(item)]
	    });
	  };
	});

/***/ },

/***/ 3913:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },

/***/ 3914:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2673);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(788);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _values = __webpack_require__(3915);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.uploadMediaToFacebookSerializer = uploadMediaToFacebookSerializer;
	exports.VariationSerializer = VariationSerializer;
	exports.postBlueprintSerializer = postBlueprintSerializer;
	exports.putBlueprintSerializer = putBlueprintSerializer;
	exports.updateLayerTemplatesTooltipSerializer = updateLayerTemplatesTooltipSerializer;
	exports.postLayerTemplatesSerializer = postLayerTemplatesSerializer;
	exports.postVariationSerializer = postVariationSerializer;
	exports.postUserVariationSerializer = postUserVariationSerializer;
	exports.postGenerateCSVSerializer = postGenerateCSVSerializer;
	
	var _effects = __webpack_require__(715);
	
	var _omit = __webpack_require__(1811);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _constants = __webpack_require__(1662);
	
	var _generic = __webpack_require__(1666);
	
	var _picasso = __webpack_require__(3888);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(postBlueprintSerializer),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintSerializer),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(postVariationSerializer),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationSerializer),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVSerializer);
	
	function uploadMediaToFacebookSerializer(payload) {
	  var media = payload.media,
	      account_id = payload.account_id;
	
	  return media.map(function (m) {
	    return {
	      is_fb_account_id: true,
	      account_id: account_id,
	      path: (0, _generic.getImageFromState)(m),
	      fileName: m.name
	    };
	  });
	}
	
	var baseBlueprintSerializer = /*#__PURE__*/_regenerator2.default.mark(function baseBlueprintSerializer(payload) {
	  var session;
	  return _regenerator2.default.wrap(function baseBlueprintSerializer$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context.sent;
	          return _context.abrupt('return', {
	            organizationId: session.currentAdvertiser,
	            createdBy: session.user.id,
	            name: payload.name,
	            type: payload.type,
	            previewUrl: payload.thumbnailImage ? (0, _generic.getImageFromState)(payload.thumbnailImage[0]) : '',
	            guideUrl: payload.guideImage ? (0, _generic.getImageFromState)(payload.guideImage[0]) : '',
	            aeFileUrl: payload.aeFile ? (0, _generic.getImageFromState)(payload.aeFile[0]) : '',
	            description: payload.description
	          });
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, baseBlueprintSerializer, this);
	});
	
	function VariationSerializer(item) {
	  return (0, _values2.default)((0, _omit2.default)(item, ["key", "preview"]));
	}
	
	function postBlueprintSerializer(payload) {
	  var result;
	  return _regenerator2.default.wrap(function postBlueprintSerializer$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(baseBlueprintSerializer, payload);
	
	        case 2:
	          result = _context2.sent;
	          return _context2.abrupt('return', result);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function putBlueprintSerializer(payload) {
	  var result;
	  return _regenerator2.default.wrap(function putBlueprintSerializer$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(baseBlueprintSerializer, payload);
	
	        case 2:
	          result = _context3.sent;
	          return _context3.abrupt('return', (0, _assign2.default)(result, {
	            id: payload.id
	          }));
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function updateLayerTemplatesTooltipSerializer(currentLayers, updatedLayers) {
	  return currentLayers.map(function (layer) {
	    var updatedLayer = updatedLayers.find(function (newLayer) {
	      return newLayer.id === layer.id;
	    });
	    return (0, _extends3.default)({}, layer, {
	      tooltip: updatedLayer.tooltip || currentLayers.tooltip || '',
	      enableUserMedia: updatedLayer.enableUserMedia
	    });
	  });
	}
	
	function postLayerTemplatesSerializer(payload) {
	  var buildSupportedItemValidator = function buildSupportedItemValidator(values) {
	    return {
	      type: 'SUPPORTED_ITEM_VALIDATOR',
	      args: values
	    };
	  };
	
	  var buildCharacterCountValidator = function buildCharacterCountValidator(value) {
	    return {
	      type: 'CHARACTER_COUNT_VALIDATOR',
	      args: value
	    };
	  };
	
	  var buildValidators = function buildValidators(item) {
	    var arrayOfValidators = [];
	    switch (item.contentType) {
	      case 'COLOR':
	        if (!item.colours) {
	          throw (0, _assign2.default)({
	            title: "Error",
	            message: 'Layer \'' + item.title + '\' requires at least one item'
	          });
	        }
	        arrayOfValidators.push(buildSupportedItemValidator(item.colours.map(function (colour) {
	          return colour.hex.replace('#', '');
	        })));
	        return arrayOfValidators;
	      case 'VIDEO':
	      case 'IMAGE':
	      case 'AUDIO':
	        {
	          if (!item.enableUserMedia && !(item.media && item.media.length)) {
	            throw (0, _assign2.default)({
	              title: "Error",
	              message: 'Layer \'' + item.title + '\' requires at least one item or \'Enable user Media\' selected'
	            });
	          }
	          var media = item.media || [];
	          arrayOfValidators.push(buildSupportedItemValidator(media.map(function (item) {
	            return (0, _generic.getImageFromState)(item);
	          })));
	          return arrayOfValidators;
	        }
	      case 'TEXT':
	        arrayOfValidators.push(buildCharacterCountValidator(['' + (item.characterCount || 1)]));
	        return arrayOfValidators;
	      default:
	        return arrayOfValidators;
	    }
	  };
	
	  return {
	    layerTemplates: payload.map(function (item) {
	      if (!item.contentType) {
	        throw (0, _assign2.default)({
	          title: "Error",
	          message: '\'Layer ' + item.title + '\' requires a type'
	        });
	      }
	
	      return {
	        title: item.title,
	        contentType: item.contentType,
	        validators: buildValidators(item),
	        tooltip: item.tooltip,
	        enableUserMedia: item.enableUserMedia
	      };
	    })
	  };
	}
	
	function postVariationSerializer(payload) {
	  var blueprint, session, user, currentAdvertiser, updatedPayload, buildVariation;
	  return _regenerator2.default.wrap(function postVariationSerializer$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 2:
	          blueprint = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 5:
	          session = _context4.sent;
	          user = session.user, currentAdvertiser = session.currentAdvertiser;
	          updatedPayload = payload.map(function (item) {
	            return (0, _assign2.default)({}, item);
	          });
	
	          buildVariation = function buildVariation() {
	            return updatedPayload.map(function (item) {
	              return VariationSerializer(item);
	            });
	          };
	
	          return _context4.abrupt('return', {
	            blueprintId: blueprint.id,
	            layers: blueprint.layerTemplates.map(function (layer) {
	              return layer.id;
	            }),
	            variations: buildVariation(),
	            userName: user.first_name + ' ' + user.last_name,
	            userEmail: user.email,
	            organizationId: currentAdvertiser
	          });
	
	        case 10:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function postUserVariationSerializer(payload) {
	  var blueprint, session, rowSerializer, payloadAsString;
	  return _regenerator2.default.wrap(function postUserVariationSerializer$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 2:
	          blueprint = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 5:
	          session = _context5.sent;
	
	          rowSerializer = function rowSerializer(item) {
	            var newItem = (0, _omit2.default)(item, ["key"]);
	            var previewObj = newItem.preview || null;
	
	            if (previewObj) {
	              // Need to omit the case where there's a local loading state for generating a Preview from Picasso, but that request hasn't finished.
	              // ie If the user reloads before there is a preview made on the backend, we can't recover it, so we'll have to omit `preview` from the row - JT
	              if (previewObj.requestingPreview) {
	                newItem = (0, _omit2.default)(newItem, ["preview"]);
	              } else if (previewObj.flashCompleted) {
	                // remove `flashCompleted` since it's purely aesthetic to show user preview is ready
	                newItem.preview = (0, _picasso.unsetPreviewFlashCompleted)(previewObj);
	              }
	            }
	
	            return newItem;
	          };
	
	          payloadAsString = (0, _generic.convertArrayToEscapedString)(payload, function (item) {
	            return (0, _stringify2.default)(rowSerializer(item));
	          });
	          return _context5.abrupt('return', {
	            organizationId: session.currentAdvertiser,
	            blueprintId: blueprint.id,
	            userId: session.user.id,
	            value: payloadAsString
	          });
	
	        case 9:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/* TODO: refactor switch logic to share it with postLayerTemplatesSerializer */
	function postGenerateCSVSerializer(_ref) {
	  var layerTemplates = _ref.layerTemplates;
	  var blueprint, arrays, header;
	  return _regenerator2.default.wrap(function postGenerateCSVSerializer$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 2:
	          blueprint = _context6.sent;
	          arrays = layerTemplates.map(function (layerTemplate) {
	            switch (layerTemplate.contentType) {
	              case 'COLOR':
	                return layerTemplate.colours ? layerTemplate.colours.map(function (colour) {
	                  return colour.hex;
	                }) : [];
	              case 'VIDEO':
	              case 'IMAGE':
	              case 'AUDIO':
	                return layerTemplate.media ? layerTemplate.media.map(function (item) {
	                  return item.url || (0, _generic.getImageFromState)(item);
	                }) : [];
	              case 'TEXT':
	                return [(0, _generic.loremIpsumTextGenerator)(layerTemplate.characterCount)];
	              default:
	                return [''];
	            }
	          });
	
	          // TEMP change, instead of creating all possible permutaions, the csv will just be one permutaion consisting of
	          // the last (most recent) value of each layer.
	          // Generating all permutations can get crazy and freezes/crashes chrome page - JT
	
	          header = layerTemplates.map(function (layerTemplate) {
	            return layerTemplate.title;
	          });
	          return _context6.abrupt('return', {
	            blueprintId: blueprint.id,
	            values: [header, arrays.map(function (arr) {
	              return arr[arr.length - 1];
	            })]
	          });
	
	        case 6:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ },

/***/ 3915:
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3916), __esModule: true };

/***/ },

/***/ 3916:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3917);
	module.exports = __webpack_require__(515).Object.values;

/***/ },

/***/ 3917:
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(513)
	  , $values = __webpack_require__(3918)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },

/***/ 3918:
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(534)
	  , toIObject = __webpack_require__(536)
	  , isEnum    = __webpack_require__(793).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },

/***/ 3919:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.currentOrganizationWatcher = currentOrganizationWatcher;
	exports.fetchAccountsWatcher = fetchAccountsWatcher;
	exports.uploadMediaToFBWatcher = uploadMediaToFBWatcher;
	exports.getBlueprintsWatcher = getBlueprintsWatcher;
	exports.deleteBlueprintWatcher = deleteBlueprintWatcher;
	exports.getLayerSchemaWatcher = getLayerSchemaWatcher;
	exports.postBlueprintWatcher = postBlueprintWatcher;
	exports.putBlueprintWatcher = putBlueprintWatcher;
	exports.postLayerTemplatesWatcher = postLayerTemplatesWatcher;
	exports.getBlueprintWatcher = getBlueprintWatcher;
	exports.postVariationWatcher = postVariationWatcher;
	exports.postGenerateCSVWatcher = postGenerateCSVWatcher;
	exports.getUserVariationWatcher = getUserVariationWatcher;
	exports.postUserVariationWatcher = postUserVariationWatcher;
	exports.getExportListWatcher = getExportListWatcher;
	exports.putExportListWatcher = putExportListWatcher;
	exports.duplicateBlueprintWatcher = duplicateBlueprintWatcher;
	exports.addCustomMediaAssetWatcher = addCustomMediaAssetWatcher;
	exports.startExportJobsPollingWatcher = startExportJobsPollingWatcher;
	
	var _effects = __webpack_require__(715);
	
	var _redux = __webpack_require__(3869);
	
	var _constants = __webpack_require__(1664);
	
	var _executors = __webpack_require__(3920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(currentOrganizationWatcher),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAccountsWatcher),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(uploadMediaToFBWatcher),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintsWatcher),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(deleteBlueprintWatcher),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(getLayerSchemaWatcher),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(postBlueprintWatcher),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintWatcher),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(postLayerTemplatesWatcher),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintWatcher),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(postVariationWatcher),
	    _marked12 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVWatcher),
	    _marked13 = /*#__PURE__*/_regenerator2.default.mark(getUserVariationWatcher),
	    _marked14 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationWatcher),
	    _marked15 = /*#__PURE__*/_regenerator2.default.mark(getExportListWatcher),
	    _marked16 = /*#__PURE__*/_regenerator2.default.mark(putExportListWatcher),
	    _marked17 = /*#__PURE__*/_regenerator2.default.mark(duplicateBlueprintWatcher),
	    _marked18 = /*#__PURE__*/_regenerator2.default.mark(addCustomMediaAssetWatcher),
	    _marked19 = /*#__PURE__*/_regenerator2.default.mark(startExportJobsPollingWatcher); // DEPRECATE/REFACTOR when fully moved to Unity
	
	function currentOrganizationWatcher() {
	  return _regenerator2.default.wrap(function currentOrganizationWatcher$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_redux.SESSION_CHANGE_ADVERTISER, _executors.currentOrganizationExecutor);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchAccountsWatcher() {
	  return _regenerator2.default.wrap(function fetchAccountsWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_FETCH_ACCOUNTS, _executors.fetchAccountsExecutor);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function uploadMediaToFBWatcher() {
	  return _regenerator2.default.wrap(function uploadMediaToFBWatcher$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_UPLOAD_MEDIA_TO_FB, _executors.uploadMediaToFBExecutor);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function getBlueprintsWatcher() {
	  return _regenerator2.default.wrap(function getBlueprintsWatcher$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)([_constants.MS_PAINT_GET_BLUEPRINTS, _redux.SESSION_CHANGE_ADVERTISER], _executors.getBlueprintsExecutor);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function deleteBlueprintWatcher() {
	  return _regenerator2.default.wrap(function deleteBlueprintWatcher$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_DELETE_BLUEPRINT, _executors.deleteBlueprintExecutor);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function getLayerSchemaWatcher() {
	  return _regenerator2.default.wrap(function getLayerSchemaWatcher$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_LAYER_SCHEMA, _executors.getLayerSchemaExecutor);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function postBlueprintWatcher() {
	  return _regenerator2.default.wrap(function postBlueprintWatcher$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_BLUEPRINT, _executors.postBlueprintExecutor);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function putBlueprintWatcher() {
	  return _regenerator2.default.wrap(function putBlueprintWatcher$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_PUT_BLUEPRINT, _executors.putBlueprintExecutor);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function postLayerTemplatesWatcher() {
	  return _regenerator2.default.wrap(function postLayerTemplatesWatcher$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_LAYER_TEMPLATES, _executors.postLayerTemplatesExecutor);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	function getBlueprintWatcher() {
	  return _regenerator2.default.wrap(function getBlueprintWatcher$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_BLUEPRINT, _executors.getBlueprintExecutor);
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	
	function postVariationWatcher() {
	  return _regenerator2.default.wrap(function postVariationWatcher$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_VARIATION, _executors.postVariationExecutor);
	
	        case 2:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}
	
	function postGenerateCSVWatcher() {
	  return _regenerator2.default.wrap(function postGenerateCSVWatcher$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_GENERATE_CSV, _executors.postGenerateCSVExecutor);
	
	        case 2:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	
	function getUserVariationWatcher() {
	  return _regenerator2.default.wrap(function getUserVariationWatcher$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          _context13.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_GET_USER_VARIATION, _executors.getUserVariationExecutor);
	
	        case 2:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}
	
	function postUserVariationWatcher() {
	  return _regenerator2.default.wrap(function postUserVariationWatcher$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          _context14.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_POST_USER_VARIATION, _executors.postUserVariationExecutor);
	
	        case 2:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this);
	}
	
	function getExportListWatcher() {
	  return _regenerator2.default.wrap(function getExportListWatcher$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          _context15.next = 2;
	          return (0, _effects.takeLatest)([_constants.MS_PAINT_GET_EXPORT_LIST, _redux.SESSION_CHANGE_ADVERTISER], _executors.getExportListExecutor);
	
	        case 2:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked15, this);
	}
	
	function putExportListWatcher() {
	  return _regenerator2.default.wrap(function putExportListWatcher$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          _context16.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_PUT_EXPORT_LIST, _executors.putExportListExecutor);
	
	        case 2:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked16, this);
	}
	
	function duplicateBlueprintWatcher() {
	  return _regenerator2.default.wrap(function duplicateBlueprintWatcher$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          _context17.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_DUPLICATE_BLUEPRINT, _executors.duplicateBlueprintExecutor);
	
	        case 2:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked17, this);
	}
	
	function addCustomMediaAssetWatcher() {
	  return _regenerator2.default.wrap(function addCustomMediaAssetWatcher$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          _context18.next = 2;
	          return (0, _effects.takeLatest)(_constants.MS_PAINT_ADD_CUSTOM_USER_ASSETS, _executors.addCustomMediaAssetExecutor);
	
	        case 2:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked18, this);
	}
	
	function startExportJobsPollingWatcher() {
	  return _regenerator2.default.wrap(function startExportJobsPollingWatcher$(_context19) {
	    while (1) {
	      switch (_context19.prev = _context19.next) {
	        case 0:
	          _context19.next = 2;
	          return (0, _effects.takeLatest)([_constants.MS_PAINT_START_EXPORT_JOB_POLLING, _constants.MS_PAINT_POST_VARIATION_SUCCESS, _constants.MS_PAINT_GET_EXPORT_LIST], _executors.exportJobFetchPollerExecutor);
	
	        case 2:
	        case 'end':
	          return _context19.stop();
	      }
	    }
	  }, _marked19, this);
	}
	
	var sagas = [currentOrganizationWatcher, fetchAccountsWatcher, uploadMediaToFBWatcher, getBlueprintsWatcher, deleteBlueprintWatcher, getLayerSchemaWatcher, postBlueprintWatcher, putBlueprintWatcher, postLayerTemplatesWatcher, getBlueprintWatcher, postVariationWatcher, postGenerateCSVWatcher, getUserVariationWatcher, postUserVariationWatcher, getExportListWatcher, putExportListWatcher, duplicateBlueprintWatcher, addCustomMediaAssetWatcher, startExportJobsPollingWatcher];
	
	exports.default = sagas;

/***/ },

/***/ 3920:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(831);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(779);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.currentOrganizationExecutor = currentOrganizationExecutor;
	exports.fetchAccountsExecutor = fetchAccountsExecutor;
	exports.uploadMediaToFBExecutor = uploadMediaToFBExecutor;
	exports.getBlueprintsExecutor = getBlueprintsExecutor;
	exports.deleteBlueprintExecutor = deleteBlueprintExecutor;
	exports.getLayerSchemaExecutor = getLayerSchemaExecutor;
	exports.postBlueprintExecutor = postBlueprintExecutor;
	exports.putBlueprintExecutor = putBlueprintExecutor;
	exports.postLayerTemplatesExecutor = postLayerTemplatesExecutor;
	exports.getBlueprintExecutor = getBlueprintExecutor;
	exports.postVariationExecutor = postVariationExecutor;
	exports.postGenerateCSVExecutor = postGenerateCSVExecutor;
	exports.getUserVariationExecutor = getUserVariationExecutor;
	exports.postUserVariationExecutor = postUserVariationExecutor;
	exports.getExportListExecutor = getExportListExecutor;
	exports.putExportListExecutor = putExportListExecutor;
	exports.duplicateBlueprintExecutor = duplicateBlueprintExecutor;
	exports.addCustomMediaAssetExecutor = addCustomMediaAssetExecutor;
	exports.exportJobFetchPollerExecutor = exportJobFetchPollerExecutor;
	
	var _axios = __webpack_require__(569);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _effects = __webpack_require__(715);
	
	var _reduxSaga = __webpack_require__(705);
	
	var _reactRouter = __webpack_require__(717);
	
	var _redux = __webpack_require__(3869);
	
	var _antd = __webpack_require__(781);
	
	var _cloneDeep = __webpack_require__(3921);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _isEqual = __webpack_require__(3208);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _differenceWith = __webpack_require__(3922);
	
	var _differenceWith2 = _interopRequireDefault(_differenceWith);
	
	var _generic = __webpack_require__(1666);
	
	var _serializers = __webpack_require__(3914);
	
	var _constants = __webpack_require__(1662);
	
	var _constants2 = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(currentOrganizationExecutor),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAccountsExecutor),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(uploadMediaToFBExecutor),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintsExecutor),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(deleteBlueprintExecutor),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(getLayerSchemaExecutor),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(postBlueprintExecutor),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintExecutor),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(postLayerTemplatesExecutor),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintExecutor),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(postVariationExecutor),
	    _marked12 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVExecutor),
	    _marked13 = /*#__PURE__*/_regenerator2.default.mark(getUserVariationExecutor),
	    _marked14 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationExecutor),
	    _marked15 = /*#__PURE__*/_regenerator2.default.mark(getExportListExecutor),
	    _marked16 = /*#__PURE__*/_regenerator2.default.mark(putExportListExecutor),
	    _marked17 = /*#__PURE__*/_regenerator2.default.mark(duplicateBlueprintExecutor),
	    _marked18 = /*#__PURE__*/_regenerator2.default.mark(addCustomMediaAssetExecutor),
	    _marked19 = /*#__PURE__*/_regenerator2.default.mark(exportJobFetchPollerExecutor);
	
	var cachedExportList = []; // cache used for when we're polling export lists to detect any changes
	
	var locationIsHomePage = function locationIsHomePage() {
	  return window.location.hash.endsWith("creative_at_scale") || window.location.hash.endsWith("creative_at_scale/") || window.location.hash.endsWith("creative_at_scale/create_blueprint") || window.location.hash.endsWith("creative_at_scale/create_blueprint/");
	};
	
	function currentOrganizationExecutor() {
	  return _regenerator2.default.wrap(function currentOrganizationExecutor$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (locationIsHomePage()) {
	            _context.next = 3;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale');
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchAccountsExecutor() {
	  var session, accounts;
	  return _regenerator2.default.wrap(function fetchAccountsExecutor$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context2.sent;
	          _context2.prev = 3;
	          _context2.next = 6;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.facebook_v3_api_url + '/accounts?advertiser_id=' + session.currentAdvertiser);
	
	        case 6:
	          accounts = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_FETCH_ACCOUNTS_SUCCESS, payload: accounts.data });
	
	        case 9:
	          _context2.next = 15;
	          break;
	
	        case 11:
	          _context2.prev = 11;
	          _context2.t0 = _context2['catch'](3);
	          _context2.next = 15;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context2.t0 });
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this, [[3, 11]]);
	}
	
	var uploadToFacebook = function uploadToFacebook(session, type, request) {
	  return _axios2.default.post(session.ENDPOINTS.facebook_v3_api_url + '/accounts/' + request.account_id + '/' + type, request).catch(function (error) {
	    return {
	      fileName: request.fileName,
	      status: error.response.status,
	      error: error
	    };
	  });
	};
	
	function uploadMediaToFBExecutor(_ref) {
	  var payload = _ref.payload;
	  var session, requests, type, result, failures, failMessage;
	  return _regenerator2.default.wrap(function uploadMediaToFBExecutor$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context3.sent;
	          _context3.prev = 3;
	          _context3.next = 6;
	          return (0, _effects.call)(_serializers.uploadMediaToFacebookSerializer, payload);
	
	        case 6:
	          requests = _context3.sent;
	          type = payload.mediaType === "IMAGE" ? "adimages" : "advideos";
	          _context3.next = 10;
	          return (0, _effects.all)(requests.map(function (r) {
	            return (0, _effects.call)(uploadToFacebook, session, type, r);
	          }));
	
	        case 10:
	          result = _context3.sent;
	          _context3.next = 13;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_UPLOAD_MEDIA_TO_FB_COMPLETE });
	
	        case 13:
	          failures = result.filter(function (res) {
	            return res.status !== 201;
	          });
	
	          if (!(failures.length > 0)) {
	            _context3.next = 20;
	            break;
	          }
	
	          failMessage = failures.map(function (fail) {
	            return _react2.default.createElement(
	              'p',
	              { style: { marginBottom: 10 } },
	              fail.fileName
	            );
	          });
	          _context3.next = 18;
	          return (0, _effects.call)(_antd.Modal.warning, {
	            title: 'The following media failed to upload to Facebook:',
	            content: failMessage
	          });
	
	        case 18:
	          _context3.next = 22;
	          break;
	
	        case 20:
	          _context3.next = 22;
	          return (0, _effects.call)(_antd.Modal.success, {
	            title: 'Your media has been successfully uploaded to Facebook.'
	          });
	
	        case 22:
	          _context3.next = 28;
	          break;
	
	        case 24:
	          _context3.prev = 24;
	          _context3.t0 = _context3['catch'](3);
	          _context3.next = 28;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context3.t0 });
	
	        case 28:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this, [[3, 24]]);
	}
	
	function getBlueprintsExecutor() {
	  var session, blueprints;
	  return _regenerator2.default.wrap(function getBlueprintsExecutor$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!locationIsHomePage()) {
	            _context4.next = 16;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 3:
	          session = _context4.sent;
	          _context4.prev = 4;
	          _context4.next = 7;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/blueprints?organizationId=' + session.currentAdvertiser);
	
	        case 7:
	          blueprints = _context4.sent;
	          _context4.next = 10;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINTS_SUCCESS, payload: blueprints.data });
	
	        case 10:
	          _context4.next = 16;
	          break;
	
	        case 12:
	          _context4.prev = 12;
	          _context4.t0 = _context4['catch'](4);
	          _context4.next = 16;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context4.t0 });
	
	        case 16:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this, [[4, 12]]);
	}
	
	function deleteBlueprintExecutor(_ref2) {
	  var payload = _ref2.payload;
	  var session;
	  return _regenerator2.default.wrap(function deleteBlueprintExecutor$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context5.sent;
	          _context5.prev = 3;
	          _context5.next = 6;
	          return (0, _effects.call)(_axios2.default.delete, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_DELETE_BLUEPRINT_SUCCESS, payload: { id: payload.id } });
	
	        case 8:
	          _context5.next = 14;
	          break;
	
	        case 10:
	          _context5.prev = 10;
	          _context5.t0 = _context5['catch'](3);
	          _context5.next = 14;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context5.t0 });
	
	        case 14:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this, [[3, 10]]);
	}
	
	function getLayerSchemaExecutor() {
	  var session, layerSchema;
	  return _regenerator2.default.wrap(function getLayerSchemaExecutor$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context6.sent;
	          _context6.prev = 3;
	          _context6.next = 6;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/layer-schema');
	
	        case 6:
	          layerSchema = _context6.sent;
	          _context6.next = 9;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_LAYER_SCHEMA_SUCCESS, payload: layerSchema.data });
	
	        case 9:
	          _context6.next = 15;
	          break;
	
	        case 11:
	          _context6.prev = 11;
	          _context6.t0 = _context6['catch'](3);
	          _context6.next = 15;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context6.t0 });
	
	        case 15:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this, [[3, 11]]);
	}
	
	function postBlueprintExecutor(_ref3) {
	  var payload = _ref3.payload;
	  var session, data, blueprint;
	  return _regenerator2.default.wrap(function postBlueprintExecutor$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context7.sent;
	          _context7.prev = 3;
	          _context7.next = 6;
	          return (0, _effects.call)(_serializers.postBlueprintSerializer, payload);
	
	        case 6:
	          data = _context7.sent;
	          _context7.next = 9;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints', data);
	
	        case 9:
	          blueprint = _context7.sent;
	          _context7.next = 12;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_BLUEPRINT_SUCCESS, payload: blueprint.data });
	
	        case 12:
	          _context7.next = 14;
	          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint/' + blueprint.data.data.id);
	
	        case 14:
	          _context7.next = 20;
	          break;
	
	        case 16:
	          _context7.prev = 16;
	          _context7.t0 = _context7['catch'](3);
	          _context7.next = 20;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context7.t0 });
	
	        case 20:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this, [[3, 16]]);
	}
	
	function putBlueprintExecutor(_ref4) {
	  var payload = _ref4.payload;
	  var session, data, blueprint;
	  return _regenerator2.default.wrap(function putBlueprintExecutor$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context8.sent;
	          _context8.prev = 3;
	          _context8.next = 6;
	          return (0, _effects.call)(_serializers.putBlueprintSerializer, payload);
	
	        case 6:
	          data = _context8.sent;
	          _context8.next = 9;
	          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + data.id + '/details', data);
	
	        case 9:
	          blueprint = _context8.sent;
	          _context8.next = 12;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_BLUEPRINT_SUCCESS, payload: blueprint.data });
	
	        case 12:
	          _context8.next = 20;
	          break;
	
	        case 14:
	          _context8.prev = 14;
	          _context8.t0 = _context8['catch'](3);
	          _context8.next = 18;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context8.t0 });
	
	        case 18:
	          _context8.next = 20;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_BLUEPRINT_FAILED });
	
	        case 20:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this, [[3, 14]]);
	}
	
	function postLayerTemplatesExecutor(_ref5) {
	  var payload = _ref5.payload;
	
	  var session, currentBlueprint, successText, data, _data, _data2;
	
	  return _regenerator2.default.wrap(function postLayerTemplatesExecutor$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context9.sent;
	          _context9.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 5:
	          currentBlueprint = _context9.sent;
	          successText = 'Congratulations! You have successfully created your blueprint.';
	          _context9.prev = 7;
	
	          if (!(window.location.hash.includes('isDuplicate=true') && currentBlueprint.layerTemplates.length !== 0)) {
	            _context9.next = 22;
	            break;
	          }
	
	          _context9.t0 = _extends3.default;
	          _context9.t1 = {};
	          _context9.t2 = currentBlueprint;
	          _context9.t3 = {
	            name: payload.blueprintName
	          };
	          _context9.next = 15;
	          return (0, _effects.call)(_serializers.postLayerTemplatesSerializer, payload.layerTemplates);
	
	        case 15:
	          _context9.t4 = _context9.sent;
	          data = (0, _context9.t0)(_context9.t1, _context9.t2, _context9.t3, _context9.t4);
	
	          successText = 'Congratulations! You have successfully duplicated your blueprint.';
	          _context9.next = 20;
	          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=true', data);
	
	        case 20:
	          _context9.next = 42;
	          break;
	
	        case 22:
	          if (!(currentBlueprint.layerTemplates.length !== 0)) {
	            _context9.next = 37;
	            break;
	          }
	
	          _context9.t5 = _extends3.default;
	          _context9.t6 = {};
	          _context9.t7 = currentBlueprint;
	          _context9.t8 = payload.blueprintName;
	          _context9.next = 29;
	          return (0, _effects.call)(_serializers.updateLayerTemplatesTooltipSerializer, currentBlueprint.layerTemplates, payload.layerTemplates);
	
	        case 29:
	          _context9.t9 = _context9.sent;
	          _context9.t10 = {
	            name: _context9.t8,
	            layerTemplates: _context9.t9
	          };
	          _data = (0, _context9.t5)(_context9.t6, _context9.t7, _context9.t10);
	
	          successText = 'Blueprint Updated.';
	          _context9.next = 35;
	          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=false', _data);
	
	        case 35:
	          _context9.next = 42;
	          break;
	
	        case 37:
	          _context9.next = 39;
	          return (0, _effects.call)(_serializers.postLayerTemplatesSerializer, payload.layerTemplates);
	
	        case 39:
	          _data2 = _context9.sent;
	          _context9.next = 42;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/layer-templates', _data2);
	
	        case 42:
	          _context9.next = 44;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_LAYER_TEMPLATES_SUCCESS });
	
	        case 44:
	          _context9.next = 46;
	          return (0, _effects.call)(_antd.Modal.success, {
	            title: successText
	          });
	
	        case 46:
	          _context9.next = 48;
	          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint');
	
	        case 48:
	          _context9.next = 56;
	          break;
	
	        case 50:
	          _context9.prev = 50;
	          _context9.t11 = _context9['catch'](7);
	          _context9.next = 54;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context9.t11 });
	
	        case 54:
	          _context9.next = 56;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_LAYER_TEMPLATES_FAILED });
	
	        case 56:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this, [[7, 50]]);
	}
	
	function getBlueprintExecutor(_ref6) {
	  var payload = _ref6.payload;
	  var session, blueprint;
	  return _regenerator2.default.wrap(function getBlueprintExecutor$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context10.sent;
	          _context10.prev = 3;
	          _context10.next = 6;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id + '/details');
	
	        case 6:
	          blueprint = _context10.sent;
	          _context10.next = 9;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINT_SUCCESS, payload: blueprint.data });
	
	        case 9:
	          _context10.next = 15;
	          break;
	
	        case 11:
	          _context10.prev = 11;
	          _context10.t0 = _context10['catch'](3);
	          _context10.next = 15;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context10.t0 });
	
	        case 15:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this, [[3, 11]]);
	}
	
	function postVariationExecutor(_ref7) {
	  var payload = _ref7.payload;
	  var session, data;
	  return _regenerator2.default.wrap(function postVariationExecutor$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context11.sent;
	          _context11.prev = 3;
	          _context11.next = 6;
	          return (0, _effects.call)(_serializers.postVariationSerializer, payload);
	
	        case 6:
	          data = _context11.sent;
	          _context11.next = 9;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/generate-variations', data);
	
	        case 9:
	          _context11.next = 11;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_VARIATION_SUCCESS });
	
	        case 11:
	          _context11.next = 13;
	          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale');
	
	        case 13:
	          _context11.next = 15;
	          return (0, _effects.call)(_antd.Modal.success, {
	            title: 'Congratulations! You have successfully created your variation.',
	            content: 'Your variation will be emailed to you within 24 hours.'
	          });
	
	        case 15:
	          _context11.next = 23;
	          break;
	
	        case 17:
	          _context11.prev = 17;
	          _context11.t0 = _context11['catch'](3);
	          _context11.next = 21;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context11.t0 });
	
	        case 21:
	          _context11.next = 23;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_VARIATION_FAILED });
	
	        case 23:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this, [[3, 17]]);
	}
	
	function postGenerateCSVExecutor(_ref8) {
	  var payload = _ref8.payload;
	  var session, blueprint, data;
	  return _regenerator2.default.wrap(function postGenerateCSVExecutor$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context12.sent;
	          _context12.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 5:
	          blueprint = _context12.sent;
	          _context12.prev = 6;
	          _context12.next = 9;
	          return (0, _effects.call)(_serializers.postGenerateCSVSerializer, payload);
	
	        case 9:
	          data = _context12.sent;
	          _context12.next = 12;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/generate-csv', data);
	
	        case 12:
	          _context12.next = 14;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_GENERATE_CSV_COMPLETE });
	
	        case 14:
	          _context12.next = 16;
	          return (0, _effects.call)(_antd.notification.success, {
	            message: "Success",
	            description: session.ENDPOINTS.palette_api_url + '/blueprints/' + blueprint.id + '/json-feed',
	            style: {
	              wordWrap: "break-word"
	            }
	          });
	
	        case 16:
	          _context12.next = 24;
	          break;
	
	        case 18:
	          _context12.prev = 18;
	          _context12.t0 = _context12['catch'](6);
	          _context12.next = 22;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context12.t0 });
	
	        case 22:
	          _context12.next = 24;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_GENERATE_CSV_COMPLETE });
	
	        case 24:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this, [[6, 18]]);
	}
	
	function getUserVariationExecutor(_ref9) {
	  var payload = _ref9.payload;
	  var session, userId, blueprintId, userVariation;
	  return _regenerator2.default.wrap(function getUserVariationExecutor$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          _context13.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context13.sent;
	          _context13.prev = 3;
	          userId = session.user.id;
	          blueprintId = payload.blueprintId;
	          _context13.next = 8;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/users/' + userId + '/blueprint/' + blueprintId + '/user-variations');
	
	        case 8:
	          userVariation = _context13.sent;
	          _context13.next = 11;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_USER_VARIATION_SUCCESS, payload: userVariation.data });
	
	        case 11:
	          _context13.next = 17;
	          break;
	
	        case 13:
	          _context13.prev = 13;
	          _context13.t0 = _context13['catch'](3);
	          _context13.next = 17;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_USER_VARIATION_FAILED });
	
	        case 17:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this, [[3, 13]]);
	}
	
	function postUserVariationExecutor(_ref10) {
	  var payload = _ref10.payload;
	  var session, data;
	  return _regenerator2.default.wrap(function postUserVariationExecutor$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          _context14.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context14.sent;
	          _context14.prev = 3;
	          _context14.next = 6;
	          return (0, _effects.call)(_serializers.postUserVariationSerializer, payload);
	
	        case 6:
	          data = _context14.sent;
	          _context14.next = 9;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/user-variations', data);
	
	        case 9:
	          _context14.next = 11;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_USER_VARIATION_SUCCESS });
	
	        case 11:
	          _context14.next = 17;
	          break;
	
	        case 13:
	          _context14.prev = 13;
	          _context14.t0 = _context14['catch'](3);
	          _context14.next = 17;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_USER_VARIATION_FAILED });
	
	        case 17:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this, [[3, 13]]);
	}
	
	function getExportListExecutor(_ref11) {
	  var payload = _ref11.payload;
	  var params, session, exportList;
	  return _regenerator2.default.wrap(function getExportListExecutor$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          if (!window.location.hash.includes("progress")) {
	            _context15.next = 17;
	            break;
	          }
	
	          // Need to make sure we're on the right route before we fetch
	          params = (0, _generic.getDateRange)(payload);
	          _context15.next = 4;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 4:
	          session = _context15.sent;
	          _context15.prev = 5;
	          _context15.next = 8;
	          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser, { params: params });
	
	        case 8:
	          exportList = _context15.sent;
	          _context15.next = 11;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_EXPORT_LIST_SUCCESS, payload: exportList.data });
	
	        case 11:
	          _context15.next = 17;
	          break;
	
	        case 13:
	          _context15.prev = 13;
	          _context15.t0 = _context15['catch'](5);
	          _context15.next = 17;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context15.t0 });
	
	        case 17:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked15, this, [[5, 13]]);
	}
	
	function putExportListExecutor(_ref12) {
	  var payload = _ref12.payload;
	  var session, data, exportList;
	  return _regenerator2.default.wrap(function putExportListExecutor$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          if (!payload.updateBackend) {
	            _context16.next = 17;
	            break;
	          }
	
	          _context16.next = 3;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 3:
	          session = _context16.sent;
	          _context16.prev = 4;
	          data = { status: "IN_PROGRESS" };
	          _context16.next = 8;
	          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/export-jobs/' + payload.data.id, data);
	
	        case 8:
	          exportList = _context16.sent;
	          _context16.next = 11;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_EXPORT_LIST_SUCCESS, payload: { data: exportList.data.data, updateBackend: false } });
	
	        case 11:
	          _context16.next = 17;
	          break;
	
	        case 13:
	          _context16.prev = 13;
	          _context16.t0 = _context16['catch'](4);
	          _context16.next = 17;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context16.t0 });
	
	        case 17:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked16, this, [[4, 13]]);
	}
	
	function duplicateBlueprintExecutor(_ref13) {
	  var payload = _ref13.payload;
	  var session, userId, duplicate;
	  return _regenerator2.default.wrap(function duplicateBlueprintExecutor$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          _context17.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context17.sent;
	          _context17.prev = 3;
	          userId = session.user.id;
	          _context17.next = 7;
	          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id + '/duplicate', { createdBy: userId });
	
	        case 7:
	          duplicate = _context17.sent;
	          _context17.next = 10;
	          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint/' + duplicate.data.data.id + '?isDuplicate=true');
	
	        case 10:
	          _context17.next = 12;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_DUPLICATE_BLUEPRINT_SUCCESS });
	
	        case 12:
	          _context17.next = 18;
	          break;
	
	        case 14:
	          _context17.prev = 14;
	          _context17.t0 = _context17['catch'](3);
	          _context17.next = 18;
	          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context17.t0 });
	
	        case 18:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked17, this, [[3, 14]]);
	}
	
	function addCustomMediaAssetExecutor(_ref14) {
	  var _layer$validators$fin;
	
	  var payload = _ref14.payload;
	  var session, blueprint, currentBlueprint, layer, addedImages, updatedBlueprint;
	  return _regenerator2.default.wrap(function addCustomMediaAssetExecutor$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          _context18.next = 2;
	          return (0, _effects.select)(function (state) {
	            return state.session;
	          });
	
	        case 2:
	          session = _context18.sent;
	          _context18.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
	          });
	
	        case 5:
	          blueprint = _context18.sent;
	          currentBlueprint = (0, _cloneDeep2.default)(blueprint);
	          layer = currentBlueprint.layerTemplates.find(function (layer) {
	            return layer.id === payload.layerId;
	          });
	          addedImages = payload.fileList.map(function (file) {
	            return file.response.data;
	          });
	
	          (_layer$validators$fin = layer.validators.find(function (item) {
	            return item.type === "SUPPORTED_ITEM_VALIDATOR";
	          }).args).push.apply(_layer$validators$fin, (0, _toConsumableArray3.default)(addedImages));
	          _context18.next = 12;
	          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=true', currentBlueprint);
	
	        case 12:
	          updatedBlueprint = _context18.sent;
	          _context18.next = 15;
	          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINT_SUCCESS, payload: updatedBlueprint.data });
	
	        case 15:
	          _context18.next = 17;
	          return (0, _effects.call)(_antd.message.destroy);
	
	        case 17:
	          _context18.next = 19;
	          return (0, _effects.call)(_antd.message.success, 'Success!');
	
	        case 19:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked18, this);
	}
	
	function exportJobFetchPollerExecutor(_ref15) {
	  var _this = this;
	
	  var payload = _ref15.payload;
	
	  var _loop;
	
	  return _regenerator2.default.wrap(function exportJobFetchPollerExecutor$(_context21) {
	    while (1) {
	      switch (_context21.prev = _context21.next) {
	        case 0:
	          _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
	            var session, exportListRes, exportList, exportJobDifferenceList, checkExportJobCompleted, params, _exportList;
	
	            return _regenerator2.default.wrap(function _loop$(_context20) {
	              while (1) {
	                switch (_context20.prev = _context20.next) {
	                  case 0:
	                    _context20.next = 2;
	                    return (0, _effects.select)(function (state) {
	                      return state.session;
	                    });
	
	                  case 2:
	                    session = _context20.sent;
	                    _context20.prev = 3;
	                    _context20.next = 6;
	                    return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser);
	
	                  case 6:
	                    exportListRes = _context20.sent;
	                    exportList = exportListRes.data.data;
	
	                    if (!(cachedExportList.length === 0)) {
	                      _context20.next = 12;
	                      break;
	                    }
	
	                    cachedExportList = exportList;
	                    _context20.next = 25;
	                    break;
	
	                  case 12:
	                    exportJobDifferenceList = (0, _differenceWith2.default)(exportList, cachedExportList, _isEqual2.default);
	
	                    if (!exportJobDifferenceList.length) {
	                      _context20.next = 24;
	                      break;
	                    }
	
	                    checkExportJobCompleted = /*#__PURE__*/_regenerator2.default.mark(function checkExportJobCompleted(exportJob) {
	                      var findJobCompleted, completedJob, checkUser, dateCreated, blueprintName, assetUrl;
	                      return _regenerator2.default.wrap(function checkExportJobCompleted$(_context19) {
	                        while (1) {
	                          switch (_context19.prev = _context19.next) {
	                            case 0:
	                              findJobCompleted = exportList.filter(function (ej) {
	                                return ej.status === 'COMPLETED' && ej.id === exportJob.id;
	                              });
	                              completedJob = findJobCompleted.length > 0 ? findJobCompleted[0] : null;
	                              checkUser = session.user.email === exportJob.userEmail;
	
	                              if (!(['QUEUED', 'IN_PROGRESS'].includes(exportJob.status) && completedJob && checkUser)) {
	                                _context19.next = 9;
	                                break;
	                              }
	
	                              dateCreated = (0, _generic.formatDateToHumanReadable)(completedJob.createdAt) || '{dateCreated}';
	                              blueprintName = completedJob.blueprintName || '{blueprintName}';
	                              assetUrl = completedJob.assetLink || '';
	                              _context19.next = 9;
	                              return (0, _effects.call)(_antd.notification.success, {
	                                message: "Creative Blueprints",
	                                description: _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Your Export Job requested at ',
	                                    _react2.default.createElement(
	                                      'strong',
	                                      null,
	                                      dateCreated
	                                    ),
	                                    ' for ',
	                                    _react2.default.createElement(
	                                      'strong',
	                                      null,
	                                      blueprintName
	                                    ),
	                                    ' has completed!'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'a',
	                                      { href: assetUrl },
	                                      'Click here to download'
	                                    )
	                                  )
	                                ),
	                                duration: 0,
	                                style: {
	                                  wordWrap: "break-word",
	                                  fontFamily: "Helvetica Neue"
	                                }
	                              });
	
	                            case 9:
	                            case 'end':
	                              return _context19.stop();
	                          }
	                        }
	                      }, checkExportJobCompleted, this);
	                    });
	                    _context20.next = 17;
	                    return (0, _effects.all)(cachedExportList.map(function (exportJob) {
	                      return (0, _effects.call)(checkExportJobCompleted, exportJob);
	                    }));
	
	                  case 17:
	                    if (!(payload && payload.dateRange)) {
	                      _context20.next = 24;
	                      break;
	                    }
	
	                    params = (0, _generic.getDateRange)(payload);
	                    _context20.next = 21;
	                    return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser, { params: params });
	
	                  case 21:
	                    _exportList = _context20.sent;
	                    _context20.next = 24;
	                    return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_EXPORT_LIST_SUCCESS, payload: _exportList.data });
	
	                  case 24:
	
	                    cachedExportList = exportList;
	
	                  case 25:
	                    _context20.next = 29;
	                    break;
	
	                  case 27:
	                    _context20.prev = 27;
	                    _context20.t0 = _context20['catch'](3);
	
	                  case 29:
	                    _context20.next = 31;
	                    return (0, _reduxSaga.delay)(_constants.EXPORT_JOBS_POLLING_DELAY);
	
	                  case 31:
	                  case 'end':
	                    return _context20.stop();
	                }
	              }
	            }, _loop, _this, [[3, 27]]);
	          });
	
	        case 1:
	          if (false) {
	            _context21.next = 5;
	            break;
	          }
	
	          return _context21.delegateYield(_loop(), 't0', 3);
	
	        case 3:
	          _context21.next = 1;
	          break;
	
	        case 5:
	        case 'end':
	          return _context21.stop();
	      }
	    }
	  }, _marked19, this);
	}

/***/ },

/***/ 3921:
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1812);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },

/***/ 3922:
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(3703),
	    baseFlatten = __webpack_require__(1671),
	    baseRest = __webpack_require__(2349),
	    isArrayLikeObject = __webpack_require__(3706),
	    last = __webpack_require__(1858);
	
	/**
	 * This method is like `_.difference` except that it accepts `comparator`
	 * which is invoked to compare elements of `array` to `values`. The order and
	 * references of result values are determined by the first array. The comparator
	 * is invoked with two arguments: (arrVal, othVal).
	 *
	 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 *
	 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }]
	 */
	var differenceWith = baseRest(function(array, values) {
	  var comparator = last(values);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	    : [];
	});
	
	module.exports = differenceWith;


/***/ }

});


// WEBPACK FOOTER //
// 5.webpack_build.js